/* ============================================================
   EPICLABS® PROTOCOL ENGINE™  — protocol-engine.js  v3.0
   Memoria · Transiciones invisibles · Escalado ELITE
   Navegación por teclado · Accesibilidad
   ============================================================ */

(function () {
  'use strict';

  var CFG      = window.EPICLABS_PE_CONFIG || {};
  var PRODUCTS = window.EPICLABS_PE_PRODUCTS || {};
  var STORE_KEY = 'epiclabs_pe_v3';

  /* ── Preguntas base ─────────────────────────────────────── */
  var QUESTIONS = {
    q1: {
      id: 'q1', layout: 'grid2',
      text: 'Cuando el esfuerzo llega al máximo, ¿qué te falla primero?',
      sublabel: 'Esto define tu protocolo.',
      options: [
        { value: 'fuerza',      label: 'La fuerza',        desc: 'Me estanco: no subo cargas ni construyo músculo',  icon: 'body'   },
        { value: 'energia',     label: 'La energía',       desc: 'Me apago a media sesión, pierdo intensidad',       icon: 'bolt'   },
        { value: 'recuperacion',label: 'La recuperación',  desc: 'No me repongo: duermo mal y llego cansado',        icon: 'moon'   },
        { value: 'resistencia', label: 'El aguante',       desc: 'Me quedo sin tanque antes de terminar',            icon: 'wave'   },
        { value: 'definicion',  label: 'La definición',    desc: 'Pierdo músculo cuando me seco',                    icon: 'flame'  },
        { value: 'base',        label: 'Aún lo estoy descubriendo', desc: 'Apenas construyo mi base de rendimiento', icon: 'shield' }
      ]
    },
    q2: {
      id: 'q2', layout: 'row',
      text: 'Sexo biológico',
      sublabel: 'Para calibrar tus dosis.',
      options: [
        { value: 'hombre', label: 'Hombre' },
        { value: 'mujer',  label: 'Mujer' },
        { value: 'ns',     label: 'No indicar' }
      ]
    },
    q4: {
      id: 'q4', layout: 'list',
      text: '¿Qué tan seguido exiges a tu cuerpo?',
      sublabel: 'Define la intensidad.',
      options: [
        { value: 'alto',         label: '5+ días — vivo en el gimnasio',   desc: 'Alto volumen, alta exigencia' },
        { value: 'constante',    label: '3–4 días — disciplina constante', desc: 'Entreno en serio, con rutina' },
        { value: 'construccion', label: '1–2 días — construyendo el hábito', desc: 'Voy subiendo la frecuencia' },
        { value: 'empezando',    label: 'Apenas arranco',                  desc: 'Sin rutina fija todavía' }
      ]
    },
    q5: {
      id: 'q5', layout: 'list',
      text: '¿Cómo responde tu sistema nervioso a la cafeína?',
      sublabel: '¿Con o sin estimulante?',
      options: [
        { value: 'tolera',   label: 'La tolero de maravilla',     desc: 'Me rinde la energía, sin rebote' },
        { value: 'tarde_no', label: 'Bien, pero no de noche',     desc: 'Me quita el sueño si entreno tarde' },
        { value: 'nervioso', label: 'Me acelera de más',          desc: 'Ansiedad o taquicardia con estimulantes' },
        { value: 'evita',    label: 'La evito por completo',      desc: 'Rindo mejor sin estimulantes' }
      ]
    },
    q6: {
      id: 'q6', layout: 'list',
      text: 'Si lo logras en 8 semanas, ¿qué notarías primero?',
      sublabel: 'El motivo real detrás de tu esfuerzo.',
      options: [
        { value: 'fisico',  label: 'Cómo se ve mi cuerpo',         icon: 'body'  },
        { value: 'sentir',  label: 'Cómo se siente mi energía',    icon: 'bolt'  },
        { value: 'numeros', label: 'Mis números: fuerza y marcas', icon: 'brain' },
        { value: 'mental',  label: 'Mi descanso y claridad mental', icon: 'moon'  }
      ]
    }
  };

  /* ── Q3 adaptativa ──────────────────────────────────────── */
  var Q3_DATA = {
    fuerza: {
      text: '¿Qué frena más tus ganancias de fuerza?',
      sublabel: 'El obstáculo más real en tu progreso.',
      options: [
        { value: 'estancamiento',  label: 'Me estanco, no subo de carga',       desc: 'Semanas sin progresar' },
        { value: 'energia_series', label: 'Me falta energía en series pesadas', desc: 'Pierdo potencia al final' },
        { value: 'recuperacion_f', label: 'No me recupero entre sesiones',      desc: 'Llego cansado al siguiente entreno' },
        { value: 'inconsistencia', label: 'Me cuesta ser constante',            desc: 'Entreno irregular' }
      ]
    },
    energia: {
      text: '¿Cuándo te falla más la energía?',
      sublabel: 'El momento crítico de tu entrenamiento.',
      options: [
        { value: 'pre_entreno',   label: 'Antes de entrenar — llego sin batería', desc: 'Me cuesta arrancar' },
        { value: 'mitad_entreno', label: 'A mitad de sesión — me apago',          desc: 'Pierdo intensidad' },
        { value: 'foco',          label: 'Foco mental — me distraigo',            desc: 'Poca conexión mente-músculo' },
        { value: 'entreno_tarde', label: 'Entreno de noche, sin cafeína',         desc: 'No quiero afectar mi sueño' }
      ]
    },
    recuperacion: {
      text: '¿Cuál es tu mayor problema de recuperación?',
      sublabel: 'Lo que más afecta tu descanso.',
      options: [
        { value: 'conciliar',   label: 'Me cuesta conciliar el sueño',      desc: 'La mente no se apaga' },
        { value: 'no_descansa', label: 'Duermo pero no descanso',           desc: 'Despierto sin energía' },
        { value: 'doms',        label: 'Dolor muscular persistente',        desc: 'Las agujetas no me sueltan' },
        { value: 'estres_rec',  label: 'Estrés que no me deja desconectar', desc: 'Tensión constante' }
      ]
    },
    resistencia: {
      text: '¿Qué limita tu capacidad de trabajo?',
      sublabel: 'El factor que te frena dentro de la sesión.',
      options: [
        { value: 'aire',              label: 'Me quedo sin aire pronto',       desc: 'Fatiga cardiovascular temprana' },
        { value: 'bombeo',            label: 'Bombeo y congestión pobres',     desc: 'Poco pump muscular' },
        { value: 'calambres',         label: 'Calambres o fatiga muscular',    desc: 'Los músculos me fallan' },
        { value: 'energia_irregular', label: 'Energía irregular en la sesión', desc: 'Subidas y bajadas' }
      ]
    },
    definicion: {
      text: '¿Qué te ha costado más al definir?',
      sublabel: 'El reto principal de tu etapa de corte.',
      options: [
        { value: 'fuerza_deficit',  label: 'Mantener fuerza en déficit',       desc: 'Pierdo músculo al bajar grasa' },
        { value: 'energia_deficit', label: 'Energía para entrenar en déficit', desc: 'Sin calorías, sin potencia' },
        { value: 'antojos',         label: 'Antojos y control del apetito',    desc: 'Me cuesta sostener la dieta' },
        { value: 'constancia_def',  label: 'Constancia a largo plazo',         desc: 'Avanzo y retrocedo' }
      ]
    },
    base: {
      text: '¿Qué quieres establecer primero?',
      sublabel: 'Tu primer pilar de rendimiento.',
      options: [
        { value: 'energia_estable', label: 'Energía estable día a día',      desc: 'Sin caídas ni depender de cafeína' },
        { value: 'descanso_base',   label: 'Buen descanso y recuperación',   desc: 'Dormir y recuperar bien' },
        { value: 'fuerza_base',     label: 'Fuerza y progreso medible',      desc: 'Ver resultados reales' },
        { value: 'sistema_simple',  label: 'Un sistema simple y sostenible', desc: 'Algo que pueda mantener' }
      ]
    }
  };

  /* ── Etiquetas cortas (chips de procesamiento) ──────────── */
  var SHORT = {
    q1: { fuerza:'Fuerza', energia:'Energía', recuperacion:'Recuperación', resistencia:'Resistencia', definicion:'Definición', base:'Base sólida' },
    q4: { alto:'5+ días/sem', constante:'3–4 días/sem', construccion:'1–2 días/sem', empezando:'Iniciando' },
    q5: { tolera:'Tolera estimulantes', tarde_no:'Estimulantes solo AM', nervioso:'Sensible a estimulantes', evita:'Sin estimulantes' }
  };

  /* ── Protocolos ─────────────────────────────────────────── */
  var PROTOCOLS = {
    alpha: {
      key:'alpha', name:'PROTOCOLO ALPHA®', profile:'Atleta de Potencia', tagline:'Fuerza y energía de alto octanaje.',
      diagnosis:'Tu fuerza ya existe. Lo único que le falta es el combustible para no colapsar en la serie que importa.',
      duration:'4–8 semanas', level:'Entrenamiento regular a intenso', badge:'Tu mejor match',
      outcome:'En 4–8 semanas: cargas más altas, energía que aguanta hasta el último rep y composición corporal que se ve en el espejo.',
      components:['CORE-X® — Energía clínica · 30 servicios · ~30 días · L-Citrulina 7g + Cafeína 220mg','CREANOVA® — Fuerza base · 100 servicios · ~60 días · Creatina 5g + B6 P-5-P'],
      accent:'#1A6BF5'
    },
    neuro: {
      key:'neuro', name:'PROTOCOLO NEURO®', profile:'Atleta Cognitivo 24H', tagline:'Stack cognitivo y físico de 24 horas.',
      diagnosis:'Cuando sincronizas mente y músculo sin depender de cafeína, el rendimiento se vuelve consistente, no puntual.',
      duration:'4–8 semanas', level:'Entrenamiento moderado a regular', badge:'Tu mejor match',
      outcome:'En 4–8 semanas: foco sostenido en sesión, fuerza progresiva semana a semana y sueño reparador real — sin un solo estimulante.',
      components:['PUMP-X® — Bombeo sin estimulantes · 30 servicios · ~30 días · L-Citrulina 7g + GABA 1,000mg','CREANOVA® — Fuerza celular · 100 servicios · ~60 días · Creatina 5g + B6 P-5-P','BIO-MAG® — Recuperación nocturna · 30 servicios · 30 días · Magnesio glicinato 141mg'],
      accent:'#7C3AED'
    },
    mitocondria: {
      key:'mitocondria', name:'PROTOCOLO MITOCONDRIA®', profile:'Constructor de Base Celular', tagline:'Energía celular y recuperación esencial.',
      diagnosis:'Sin base celular sólida, ningún stack avanzado funciona al 100%. Aquí se construye todo lo demás.',
      duration:'8–12 semanas', level:'Todos los niveles', badge:'Tu mejor match',
      outcome:'En 8–12 semanas: energía que no se cae a las 3 PM, sueño de recuperación real y marcadores de rendimiento medibles.',
      components:['CREANOVA® — Fosfocreatina muscular · 100 servicios · ~60 días · Creatina 5g + B6 P-5-P','BIO-MAG® — Energía enzimática · 30 servicios · 30 días · Magnesio glicinato 141mg'],
      accent:'#059669'
    },
    base: {
      key:'base', name:'PROTOCOLO BASE®', profile:'Atleta de Sistema Limpio', tagline:'Rendimiento limpio y descanso real.',
      diagnosis:'Rendir sin estimulantes es la habilidad más valiosa. Este sistema la construye desde adentro.',
      duration:'4–8 semanas', level:'Inicio o sensible a estimulantes', badge:'Tu mejor match',
      outcome:'En 4–8 semanas: sueño real de 7–9h, cortisol nocturno bajo y energía estable sin necesitar café para arrancar.',
      components:['PUMP-X® — Bombeo limpio · 30 servicios · ~30 días · L-Citrulina 7g + GABA 1,000mg','BIO-MAG® — Recuperación nocturna · 30 servicios · 30 días · Magnesio glicinato 141mg'],
      accent:'#0891B2'
    },
    peak: {
      key:'peak', name:'PROTOCOLO PEAK®', profile:'Ejecutivo de Alto Rendimiento', tagline:'Rendimiento AM + recuperación hormonal PM.',
      diagnosis:'La sesión de hoy es la mitad. El que cierra el ciclo de 24h con recuperación hormonal real es el que gana.',
      duration:'4–8 semanas', level:'Entrenamiento regular a intenso', badge:'Tu mejor match',
      outcome:'En 4–8 semanas: sesiones AM al tope + cortisol y testosterona balanceados para ciclos 24h sin déficit acumulado.',
      components:['CORE-X® — Energía explosiva AM · 30 servicios · ~30 días · Cafeína 220mg + Rhodiola 400mg','BIO-MAG® — Recuperación hormonal PM · 30 servicios · 30 días · Magnesio glicinato 141mg'],
      accent:'#DC2626'
    },
    elite: {
      key:'elite', name:'PROTOCOLO ELITE®', profile:'Atleta Élite Sin Compromisos', tagline:'El stack completo. Para quien no hace compromisos.',
      diagnosis:'Los atletas que llegan lejos no dejan ningún sistema sin cubrir. Energía, bombeo, fuerza y recuperación: los 4 activos.',
      duration:'8–12 semanas', level:'Alto rendimiento', badge:'Nivel máximo',
      outcome:'En 8–12 semanas: los 4 sistemas en sincronía. Nada queda descubierto, nada te frena.',
      components:['CORE-X® — Energía clínica AM · 30 servicios · ~30 días · L-Citrulina 7g + Cafeína 220mg','PUMP-X® — Bombeo sin estimulantes · 30 servicios · ~30 días · L-Citrulina 7g + GABA 1,000mg','CREANOVA® — Fuerza base · 100 servicios · ~60 días · Creatina 5g + B6 P-5-P','BIO-MAG® — Recuperación nocturna · 30 servicios · 30 días · Magnesio glicinato 141mg'],
      accent:'#D97706'
    }
  };

  /* ── Motor de puntuación ────────────────────────────────── */
  function computeScores(a) {
    var s = { alpha:0, neuro:0, mitocondria:0, base:0, peak:0, elite:0 };

    apply(s, ({
      fuerza:       { alpha:24, mitocondria:10, neuro:6 },
      energia:      { alpha:24, peak:12, neuro:4 },
      recuperacion: { base:24, peak:10, mitocondria:6 },
      resistencia:  { neuro:20, base:12, alpha:8 },
      definicion:   { alpha:18, peak:12, neuro:10 },
      base:         { mitocondria:24, base:12, neuro:4 }
    })[a.q1]);

    apply(s, ({
      estancamiento:{ mitocondria:15, alpha:10 }, energia_series:{ alpha:18, peak:7 },
      recuperacion_f:{ peak:13, mitocondria:12 }, inconsistencia:{ mitocondria:13, base:12 },
      pre_entreno:{ alpha:18, peak:7 }, mitad_entreno:{ alpha:15, neuro:10 },
      foco:{ neuro:15, alpha:10 }, entreno_tarde:{ neuro:18, base:7 },
      conciliar:{ base:18, mitocondria:7 }, no_descansa:{ base:15, peak:10 },
      doms:{ mitocondria:15, peak:10 }, estres_rec:{ base:18, neuro:7 },
      aire:{ neuro:13, mitocondria:12 }, bombeo:{ neuro:18, base:7 },
      calambres:{ base:15, mitocondria:10 }, energia_irregular:{ mitocondria:13, alpha:12 },
      fuerza_deficit:{ alpha:15, mitocondria:10 }, energia_deficit:{ alpha:18, peak:7 },
      antojos:{ neuro:13, base:12 }, constancia_def:{ mitocondria:13, neuro:12 },
      energia_estable:{ mitocondria:15, neuro:10 }, descanso_base:{ base:15, mitocondria:10 },
      fuerza_base:{ alpha:13, mitocondria:12 }, sistema_simple:{ mitocondria:15, base:10 }
    })[a.q3]);

    apply(s, ({
      alto:{ alpha:9, peak:6, elite:3 }, constante:{ neuro:8, alpha:5, mitocondria:3 },
      construccion:{ base:7, mitocondria:6, neuro:3 }, empezando:{ base:11, mitocondria:5 }
    })[a.q4]);

    apply(s, ({
      tolera:{ alpha:8, peak:6 }, tarde_no:{ peak:3, neuro:4, alpha:2 },
      nervioso:{ base:8, neuro:6 }, evita:{ base:10, neuro:8 }
    })[a.q5]);

    if (a.q2 === 'mujer')  { s.base += 3; s.mitocondria += 2; }
    if (a.q2 === 'hombre') { s.alpha += 3; s.peak += 2; }

    apply(s, ({
      fisico:{ alpha:3, peak:2 }, sentir:{ mitocondria:3, neuro:2 },
      numeros:{ alpha:2, peak:3 }, mental:{ base:3, neuro:2 }
    })[a.q6]);

    if (a.q5 === 'evita')    { s.alpha *= 0.42; s.peak *= 0.52; s.elite *= 0.55; }
    if (a.q5 === 'nervioso') { s.alpha *= 0.62; s.peak *= 0.72; }

    if (a.q4 === 'alto' && a.q5 === 'tolera') {
      s.elite = Math.max(s.alpha, s.peak, s.neuro) + 8;
    }
    return s;
  }

  function apply(s, map) {
    if (!map) return;
    for (var k in map) if (map.hasOwnProperty(k)) s[k] = (s[k]||0) + map[k];
  }

  function selectProtocol(s) {
    var best = 'mitocondria', top = -1;
    for (var k in s) if (s.hasOwnProperty(k) && s[k] > top) { top = s[k]; best = k; }
    return best;
  }

  /* ── Texto explicativo ──────────────────────────────────── */
  function generateWhyText(key, a) {
    var obj = ({
      fuerza:'fuerza', energia:'energía', recuperacion:'recuperación',
      resistencia:'aguante', definicion:'definición', base:'tu base'
    })[a.q1] || 'tu rendimiento';
    var reason = ({
      alpha:'CORE-X (L-Citrulina 7g + Cafeína 220mg de guaraná) enciende cada sesión. CREANOVA (5g Creatina diaria, 100 servicios) construye fuerza semana a semana.',
      neuro:'PUMP-X (Citrulina 7g + GABA 1g, sin cafeína) da bombeo y foco limpio. CREANOVA suma fuerza. BIO-MAG (Mg glicinato) repara de noche.',
      mitocondria:'CREANOVA recarga tu fosfocreatina muscular (5g por servicio, 100 tomas). BIO-MAG activa 300+ reacciones enzimáticas de recuperación cada noche.',
      base:'PUMP-X (Citrulina 7g + GABA 1g, cero estimulantes) rinde limpio. BIO-MAG (141mg Mg glicinato) restaura tu sistema nervioso mientras duermes.',
      peak:'CORE-X (Cafeína 220mg + Rhodiola 400mg) maximiza tu sesión AM. BIO-MAG equilibra cortisol y testosterona de noche para cerrar el ciclo.',
      elite:'4 sistemas activos: CORE-X (energía AM), PUMP-X (bombeo sin estimulantes), CREANOVA (fuerza diaria, 100 servicios) y BIO-MAG (recuperación nocturna).'
    })[key] || 'el sistema más preciso para tu perfil.';
    /* Corto a propósito: la gente escanea, no lee párrafos. */
    return 'Para tu <b>' + obj + '</b>: ' + reason;
  }

  /* ── Íconos ─────────────────────────────────────────────── */
  function icon(name, size) {
    size = size || 18;
    var I = {
      body:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="2"/><path d="M5 22v-5l2-3 5 2 5-2 2 3v5"/><path d="M7 9l5 1 5-1"/></svg>',
      bolt:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
      moon:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
      wave:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>',
      flame: '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>',
      shield:'<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
      brain: '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/></svg>',
      check: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="2 6 5 9 10 3"/></svg>',
      arrow: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
      back:  '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
      chevUp:'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>',
      clock: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      bar:   '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>',
      lab:   '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6"/><path d="M10 3v6.5L4 20h16L14 9.5V3"/></svg>',
      star:  '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
      starGold:'<svg width="13" height="13" viewBox="0 0 24 24" fill="#F5A623" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
      user:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
      clip:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2h6a2 2 0 0 1 2 2v0H7v0a2 2 0 0 1 2-2z"/><path d="M7 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"/><path d="M8 11h8M8 15h5"/></svg>',
      chart: '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 15l3-4 3 2 4-6"/></svg>',
      layers:'<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
      flask: '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6"/><path d="M10 3v6.5L4 20h16L14 9.5V3"/><path d="M8.5 14h7"/></svg>',
      truck: '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
      lock:  '<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
      ok:    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>'
    };
    return I[name] || '';
  }

  /* ── Estado ─────────────────────────────────────────────── */
  var state = {
    answers: {}, flow: ['q1','q2','q3','q4','q5','q6'],
    index: 0, result: null, busy: false, screen: 'intro'
  };

  /* ── Memoria (localStorage) ─────────────────────────────── */
  function saveMemory() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({
        answers: state.answers, index: state.index, result: state.result, ts: Date.now()
      }));
    } catch (e) {}
  }
  function loadMemory() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !d.ts || Date.now() - d.ts > 1209600000) { localStorage.removeItem(STORE_KEY); return null; }
      return d;
    } catch (e) { return null; }
  }
  function clearMemory() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }

  /* ── Utilidades ─────────────────────────────────────────── */
  function money(cents) {
    return '$' + Math.round((cents || 0) / 100).toLocaleString('es-MX');
  }
  function getQuestionConfig(qId) {
    if (qId === 'q3') {
      var d = Q3_DATA[state.answers.q1] || Q3_DATA.base;
      return { id:'q3', layout:'list', text:d.text, sublabel:d.sublabel, options:d.options };
    }
    return QUESTIONS[qId];
  }

  /* ── Progreso segmentado ────────────────────────────────── */
  function buildProgress() {
    var el = document.getElementById('pe-progress');
    if (!el || el.childNodes.length) return;
    for (var i = 0; i < state.flow.length; i++) {
      var s = document.createElement('span');
      s.className = 'pe__progress-seg';
      el.appendChild(s);
    }
  }
  function setStep(n, complete) {
    var el = document.getElementById('pe-progress');
    if (!el) return;
    var segs = el.children;
    for (var i = 0; i < segs.length; i++) {
      segs[i].className = 'pe__progress-seg';
      if (complete || i < n) segs[i].classList.add('is-filled');
      else if (i === n && n >= 0) segs[i].classList.add('is-active');
    }
    el.setAttribute('aria-valuenow', complete ? 100 : Math.round((n / state.flow.length) * 100));
  }

  /* ── Render: opción ─────────────────────────────────────── */
  function renderOption(opt, qId, layout, num) {
    var hasIcon = opt.icon && layout !== 'row';
    var iconHtml = hasIcon ? '<span class="pe__option-icon">' + icon(opt.icon, 16) + '</span>' : '';
    if (layout === 'row') {
      return '<button class="pe__option" data-pe-option="'+opt.value+'" data-pe-qid="'+qId+'" type="button">'
        + '<span class="pe__option-label">'+opt.label+'</span>'
        + '<span class="pe__option-check">'+icon('check')+'</span></button>';
    }
    var desc = opt.desc ? '<span class="pe__option-desc">'+opt.desc+'</span>' : '';
    return '<button class="pe__option" data-pe-option="'+opt.value+'" data-pe-qid="'+qId+'" type="button">'
      + iconHtml
      + '<span class="pe__option-text"><span class="pe__option-label">'+opt.label+'</span>'+desc+'</span>'
      + '<span class="pe__option-check">'+icon('check')+'</span></button>';
  }

  /* ── Render: intro (con memoria) ────────────────────────── */
  function renderIntro(saved) {
    var resumeHtml = '';
    var ctaLabel = CFG.cta || 'INICIAR EVALUACIÓN';

    if (saved && saved.result && PROTOCOLS[saved.result]) {
      resumeHtml = '<div class="pe__resume">'
        + '<span class="pe__resume-icon" style="color:#fff;">'+icon('lab',17)+'</span>'
        + '<span class="pe__resume-text">'
          + '<span class="pe__resume-label">Tu evaluación anterior</span>'
          + '<span class="pe__resume-name">'+PROTOCOLS[saved.result].name+'</span>'
        + '</span>'
        + '<button class="pe__resume-btn" data-pe-resume="result" type="button">Ver protocolo</button>'
        + '</div>';
      ctaLabel = 'HACER NUEVA EVALUACIÓN';
    } else if (saved && saved.index > 0 && saved.answers && Object.keys(saved.answers).length) {
      resumeHtml = '<div class="pe__resume">'
        + '<span class="pe__resume-icon" style="color:#fff;">'+icon('lab',17)+'</span>'
        + '<span class="pe__resume-text">'
          + '<span class="pe__resume-label">Evaluación en progreso</span>'
          + '<span class="pe__resume-name">Pregunta '+(saved.index+1)+' de '+state.flow.length+'</span>'
        + '</span>'
        + '<button class="pe__resume-btn" data-pe-resume="quiz" type="button">Continuar</button>'
        + '</div>';
    }

    /* Avatares de prueba social (fotos del editor o degradados) */
    var avatars = CFG.avatars || [];
    var avHtml = '';
    for (var i = 0; i < 4; i++) {
      if (avatars[i]) {
        avHtml += '<span class="pe__av"><img src="'+avatars[i]+'" alt="" loading="lazy" width="32" height="32"></span>';
      } else {
        avHtml += '<span class="pe__av pe__av--g'+(i+1)+'">'+icon('user',13)+'</span>';
      }
    }

    /* Estrellas */
    var rating = CFG.proof_rating || '4.9';
    var starsHtml = '';
    for (var s = 0; s < 5; s++) starsHtml += icon('starGold');

    /* compact_intro: la sección ya muestra el encabezado arriba → no repetir overline/heading/sub aquí */
    var introHead = CFG.compact_intro ? '<span tabindex="-1" data-pe-focus style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Evaluación</span>'
      : '<p class="pe__intro-overline">'+icon('lab',13)+'&nbsp;'+(CFG.overline||'SISTEMA DE EVALUACIÓN EPICLABS®')+'</p>'
        + '<h2 class="pe__intro-title" tabindex="-1" data-pe-focus>'+(CFG.heading||'Descubre tu Protocolo™')+'</h2>'
        + '<p class="pe__intro-sub">'+(CFG.subheading||'El suplemento equivocado no suma — te detiene. 6 preguntas y te asignamos el protocolo exacto para tu perfil.')+'</p>';
    return '<div class="pe__screen pe__screen--intro">'
      + '<span class="pe__aurora" aria-hidden="true"></span>'
      + resumeHtml
      + introHead
      + '<div class="pe__intro-meta">'
        + '<span class="pe__intro-meta-item">'+icon('clock')+'&nbsp;~60 segundos</span>'
        + '<span class="pe__intro-meta-sep"></span>'
        + '<span class="pe__intro-meta-item">'+icon('clip')+'&nbsp;6 preguntas</span>'
        + '<span class="pe__intro-meta-sep"></span>'
        + '<span class="pe__intro-meta-item">'+icon('bolt',14)+'&nbsp;Resultado al instante</span>'
      + '</div>'
      + '<div class="pe__intro-features">'
        + introFeature('chart', '6 variables · diagnóstico clínico', '')
        + introFeature('layers', 'Un protocolo exacto, no genérico', '')
        + introFeature('flask', 'Fórmulas verificadas por nutriólogo', '')
      + '</div>'
      + '<button class="pe__btn pe__btn-primary" data-pe-start type="button">'+ctaLabel+'&nbsp;&nbsp;'+icon('arrow')+'</button>'
      + '<div class="pe__intro-social">'
        + '<div class="pe__intro-avatars">'+avHtml+'</div>'
        + '<div class="pe__intro-social-info">'
          + '<div class="pe__intro-stars">'+starsHtml+'<strong>'+rating+'</strong></div>'
          + '<div class="pe__intro-social-count">'+(CFG.proof_count||'+1,000 protocolos asignados este mes')+'</div>'
        + '</div>'
      + '</div>'
      + '</div>';
  }

  /* ── Fila de característica del intro ───────────────────── */
  function introFeature(ic, title, desc) {
    return '<div class="pe__intro-feature'+(desc ? '' : ' pe__intro-feature--compact')+'">'
      + '<span class="pe__intro-feature-icon">'+icon(ic, 17)+'</span>'
      + '<span class="pe__intro-feature-text">'
        + '<strong>'+title+'</strong>'
        + (desc ? '<span>'+desc+'</span>' : '')
      + '</span>'
      + '</div>';
  }

  /* ── Render: pregunta ───────────────────────────────────── */
  function renderQuestion(qId) {
    var q = getQuestionConfig(qId);
    var idx = state.index + 1, total = state.flow.length;
    var cls = 'pe__options';
    if (q.layout === 'grid2') cls += ' pe__options--grid2';
    if (q.layout === 'row')   cls += ' pe__options--row';
    var opts = q.options.map(function (o, i) { return renderOption(o, qId, q.layout, i+1); }).join('');
    var back = state.index > 0
      ? '<button class="pe__q-back" data-pe-back type="button">'+icon('back')+'&nbsp;Atrás</button>'
      : '<span></span>';
    return '<div class="pe__screen pe__screen--question">'
      + '<span class="pe__aurora" aria-hidden="true"></span>'
      + '<div class="pe__q-meta"><span class="pe__q-counter">'+idx+' / '+total+'</span>'+back+'</div>'
      + '<p class="pe__q-text" tabindex="-1" data-pe-focus>'+q.text+'</p>'
      + '<p class="pe__q-sublabel">'+q.sublabel+'</p>'
      + '<div class="'+cls+'">'+opts+'</div>'
      + '</div>';
  }

  /* ── Render: procesamiento ──────────────────────────────── */
  function renderProcessing() {
    return '<div class="pe__screen pe__hud-screen">'
      + '<div class="pe__hud">'
        + '<div class="pe__hud-aurora" aria-hidden="true"></div>'
        + '<canvas class="pe__iso" data-pe-iso aria-hidden="true"></canvas>'
        + '<div class="pe__hud-pct"><span data-pe-pct>0</span><i>%</i></div>'
        + '<div class="pe__hud-status" data-pe-status>Iniciando análisis</div>'
        + '<p class="pe__hud-sig">EPICLABS® PROTOCOL ENGINE™</p>'
      + '</div>'
      + '</div>';
  }

  /* ── Render: tarjeta de escalado ELITE ──────────────────── */
  function renderEliteUpgrade() {
    var ep = PRODUCTS.elite || {};
    var url = ep.url || '/collections/all';
    var priceTxt = (ep.price && ep.price > 0) ? '<span class="pe__elite-price">'+money(ep.price)+'</span>' : icon('arrow');
    return '<div class="pe__elite">'
      + '<div class="pe__elite-glow" aria-hidden="true"></div>'
      + '<div class="pe__elite-top">'
        + '<span class="pe__elite-crown">'+icon('chevUp')+'</span>'
        + '<span class="pe__elite-tier">Nivel máximo EPICLABS®</span>'
      + '</div>'
      + '<h4 class="pe__elite-name">PROTOCOLO ELITE®</h4>'
      + '<p class="pe__elite-desc">Tu protocolo cubre lo esencial. <b>ELITE</b> activa los 4 sistemas en sincronía. Energía, bombeo, fuerza y recuperación, sin un solo punto ciego.</p>'
      + '<div class="pe__elite-stack">'
        + '<span class="pe__elite-pill">CORE-X®</span><span class="pe__elite-pill">PUMP-X®</span>'
        + '<span class="pe__elite-pill">CREANOVA®</span><span class="pe__elite-pill">BIO-MAG®</span>'
      + '</div>'
      + '<a class="pe__elite-cta" href="'+url+'" data-pe-elite><span>Subir a Protocolo Elite</span>'+priceTxt+'</a>'
      + '</div>';
  }

  /* ── Render: VALUE STACK (Hormozi) ───────────────────────
     Apila TODO lo que se lleva con el protocolo, cada bono con su valor, para que
     el total ($1,097+ gratis) aplaste al precio. Solo bonos REALES y entregables.
     Garantía money-back: te devolvemos tu dinero a 30 días. */
  function renderValueStack() {
    var items = [
      { svg:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
        t:'Guía de dosis personalizada en PDF', s:'Tu protocolo con dosis y horarios, firmado por el nutriólogo.', was:'$299' },
      { svg:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.2A8.4 8.4 0 0 1 12 3a8.5 8.5 0 0 1 9 8.5z"/></svg>',
        t:'Asesoría por WhatsApp con el formulador', s:'Resuelve dudas con quien diseñó tu fórmula. Acompañamiento real.', was:'$499' },
      { svg:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2.5" width="12" height="19" rx="3"/><path d="M11 18.5h2"/></svg>',
        t:'EPIC App, 30 días gratis con tu compra', s:'Tu plan de dieta y entrenamiento con tus datos. Sola cuesta $299 al mes.', was:'$299' },
      { svg:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
        t:'Certificado de pureza del lote (COA)', s:'El análisis de tu lote, en la caja. Sabes exactamente qué tomas.', tag:'INCLUIDO' },
      { svg:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"/><path d="m9 12 2 2 4-4"/></svg>',
        t:'Garantía 30 días de satisfacción', s:'Si no sientes la diferencia, te devolvemos tu dinero, sin preguntas.', tag:'SIN RIESGO' }
    ];
    var rows = items.map(function (it) {
      var right = it.was
        ? '<span class="pe__vstk-val"><s>'+it.was+'</s><em>GRATIS</em></span>'
        : '<span class="pe__vstk-tag">'+it.tag+'</span>';
      return '<li class="pe__vstk-row">'
        + '<span class="pe__vstk-ic">'+it.svg+'</span>'
        + '<span class="pe__vstk-txt"><b>'+it.t+'</b><small>'+it.s+'</small></span>'
        + right
      + '</li>';
    }).join('');
    return '<div class="pe__vstk">'
      + '<div class="pe__vstk-head"><span class="pe__vstk-over">TODO LO QUE RECIBES HOY</span>'
        + '<h4 class="pe__vstk-title">Tu protocolo, y mucho más</h4></div>'
      + '<ul class="pe__vstk-list">'+rows+'</ul>'
      + '<div class="pe__vstk-total"><span>Los extras valen <b>$1,097+</b> y van GRATIS con tu protocolo.</span></div>'
    + '</div>';
  }

  /* ── Render: resultado ──────────────────────────────────── */
  function renderResult(key) {
    var p = PROTOCOLS[key];
    var prod = PRODUCTS[key] || {};
    var why = generateWhyText(key, state.answers);
    var components = p.components.map(function (c) {
      return '<span class="pe__result-component"><span class="pe__result-component-dot"></span>'+c+'</span>';
    }).join('');

    var url = prod.url || '/collections/all';
    var hasVariant = prod.variant_id && prod.variant_id !== null && prod.variant_id !== 'null';

    var priceHtml = '';
    if (prod.price && prod.price > 0) {
      var was = (prod.compare && prod.compare > prod.price) ? '<span class="pe__result-price-was">'+money(prod.compare)+'</span>' : '';
      var save = (prod.compare && prod.compare > prod.price) ? '<span class="pe__result-price-save">Ahorras '+money(prod.compare-prod.price)+'</span>' : '';
      priceHtml = '<div class="pe__result-price"><span class="pe__result-price-now">'+money(prod.price)+'</span>'+was+save+'</div>';
    }

    var repeatSvg = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';
    var ctaHtml;
    if (hasVariant) {
      /* Suscripción retirada: los paquetes ya no son suscribibles. CTA único = agregar al carrito. */
      ctaHtml = '<button class="pe__btn pe__btn-primary" data-pe-add-cart="'+prod.variant_id+'" type="button">AGREGAR PROTOCOLO AL CARRITO</button>';
    } else {
      ctaHtml = '<a class="pe__btn pe__btn-primary" href="'+url+'" data-pe-view-product="'+key+'">VER MI '+p.name+'&nbsp;&nbsp;'+icon('arrow')+'</a>';
    }

    var successHtml = '<div class="pe__cart-success" id="pe-cart-success">'+icon('ok')
      + '&nbsp;Agregado a tu carrito&nbsp;·&nbsp;<a href="/checkout">Ir a pagar</a></div>';

    var eliteHtml = (key !== 'elite') ? renderEliteUpgrade() : '';

    /* Visual del producto — foto del protocolo recomendado */
    var rgb = hexToRgb(p.accent);
    var visualHtml = '<div class="pe__result-visual" style="background:linear-gradient(160deg,rgba('+rgb+',0.10),rgba('+rgb+',0.02));">';
    if (prod.image) {
      visualHtml += '<img src="'+prod.image+'" alt="'+p.name+'" loading="eager" width="320" height="320">';
    } else {
      visualHtml += '<div class="pe__result-visual-ph">'+icon('flask',40)+'</div>';
    }
    visualHtml += '<span class="pe__result-visual-tag">'+icon('star')+'&nbsp;'+p.badge+'</span>'
      + '</div>';

    /* Fila de confianza — anticipa dudas de compra */
    var trustHtml = '<div class="pe__result-trust">'
      + '<span class="pe__result-trust-item">'+icon('truck',13)+'&nbsp;'+(CFG.trust_ship||'Envío a todo México')+'</span>'
      + '<span class="pe__result-trust-item">'+icon('lock',13)+'&nbsp;'+(CFG.trust_pay||'Pago 100% seguro')+'</span>'
      + '<span class="pe__result-trust-item">'+icon('shield',13)+'&nbsp;'+(CFG.trust_guarantee||'30 días, te devolvemos tu dinero')+'</span>'
      + '</div>';

    /* Descuento POR VOLUMEN (se SUMA · la suscripción es el héroe a −15%):
       · 2 productos = 5%  (alpha, mito, base, peak)
       · 3 productos = 8%  (neuro)
       · 4 productos = 10% (elite · máximo volumen) */
    var pct, prodCount;
    if (key === 'elite')      { pct = 10; prodCount = 4; }
    else if (key === 'neuro') { pct = 8;  prodCount = 3; }
    else                       { pct = 5;  prodCount = 2; }  // alpha · mito · base · peak

    /* Dos opciones — Compra única primero (menor fricción), Suscripción como upgrade.
       CRO: mostrar la opción sin compromiso primero reduce la barrera de entrada. */
    var subHtml = '<div class="pe__sub pe__sub--disc">'
      + '<p class="pe__sub-title">Elige cómo llevarlo</p>'
      + '<div class="pe__disc-opts">'
        + '<div class="pe__disc-opt">'
          + '<div class="pe__disc-opt-head">'
            + '<span class="pe__disc-opt-name">Compra única</span>'
            + '<span class="pe__disc-opt-pct pe__disc-opt-pct--alt">'+pct+'% menos</span>'
          + '</div>'
          + '<p class="pe__disc-opt-desc">Precio de lista, sin compromiso ni suscripción.</p>'
        + '</div>'
        + '<div class="pe__disc-opt pe__disc-opt--hero">'
          + '<div class="pe__disc-opt-head">'
            + '<span class="pe__disc-opt-name">Suscripción</span>'
            + '<span class="pe__disc-opt-pct">15% menos · mejor precio</span>'
          + '</div>'
          + '<p class="pe__disc-opt-desc">El mejor precio, siempre. Cancela cuando quieras.</p>'
        + '</div>'
      + '</div>'
      + '</div>';

    /* ── Oferta SECUNDARIA no bloqueante · PLAN PERSONALIZADO en PDF ──
       Roberto aprobó: el resultado + el botón de carrito ya están visibles.
       Esto es una invitación sutil a dejar el correo para recibir el plan
       personalizado en PDF (recomendaciones específicas + instrucciones para
       seguir el protocolo). Reutiliza sendKlaviyo() vía handlePlanLead(). */
    var planOfferHtml = '';
    if (CFG.klaviyo_key && CFG.klaviyo_list) {
      var planWa = CFG.lead_whatsapp
        ? '<input class="pe__lead-input" type="tel" inputmode="tel" data-pe-plan-wa placeholder="WhatsApp (opcional)" autocomplete="tel">'
        : '';
      planOfferHtml = '<div class="pe__plan" data-pe-plan-offer>'
        + '<div class="pe__plan-head">'
          + '<span class="pe__plan-ico">'
            + '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>'
          + '</span>'
          + '<div class="pe__plan-copy">'
            + '<p class="pe__plan-title">Llévate tu PLAN PERSONALIZADO en PDF</p>'
            + '<p class="pe__plan-sub">Déjanos tu correo y te enviamos tu plan en PDF con recomendaciones específicas e instrucciones para seguir tu protocolo ' + p.name + '.</p>'
          + '</div>'
        + '</div>'
        + '<form class="pe__plan-form" data-pe-plan-form novalidate>'
          + '<input class="pe__lead-input" type="email" required data-pe-plan-email placeholder="tu@correo.com" autocomplete="email">'
          + planWa
          + '<button class="pe__btn pe__btn-primary pe__plan-btn" type="submit">Enviarme mi plan en PDF</button>'
        + '</form>'
        + '<p class="pe__plan-ok" data-pe-plan-ok hidden>' + icon('ok') + '&nbsp;Listo. Te enviamos tu plan y abrimos tu PDF.</p>'
        + '<p class="pe__lead-priv">Sin spam. Solo tu plan y guía. Cancela cuando quieras.</p>'
      + '</div>';
    }

    /* Firma del especialista — autoridad clínica en cada resultado */
    var signMark = CFG.founder_photo
      ? '<img class="pe__sign-photo" src="'+CFG.founder_photo+'" alt="" loading="lazy" width="48" height="48">'
      : '<div class="pe__sign-mark">'+icon('lab',16)+'</div>';
    var signHtml = '<div class="pe__sign">'
      + signMark
      + '<div class="pe__sign-text">'
        + '<span class="pe__sign-by">Protocolo validado por</span>'
        + '<strong class="pe__sign-name">'+(CFG.founder_name || 'LN. Esp. Roberto Franco')+'</strong>'
        + '<span class="pe__sign-cred">'+(CFG.founder_cred || 'Nutriólogo · Especialista en Bioquímica Molecular y Electrofisiología · Cédula Prof. 15287197 SEP')+'</span>'
      + '</div>'
      + '</div>';

    /* Guardar el resultado para /tu-progreso (si el usuario entra a su app) */
    try { localStorage.setItem('epicProtocol', JSON.stringify({ key:key, profile:p.profile, name:p.name, url:(prod.url||''), variant:(prod.variant_id||''), price:(prod.price||0), ts:Date.now() })); } catch (e) {}

    /* Emitir evento global para que epic-push.js + epic-island.js reaccionen */
    try {
      document.dispatchEvent(new CustomEvent('epic:protocol:completed', {
        detail: { key: key, name: p.name, profile: p.profile, url: (prod.url||'') }
      }));
    } catch (e) {}

    return '<div class="pe__screen pe__screen--flush">'
      + '<span class="pe__aurora pe__aurora--result" aria-hidden="true"></span>'
      + '<div class="pe__result-accent" style="background:linear-gradient(90deg,'+p.accent+',rgba('+rgb+',0.25));"></div>'
      + visualHtml
      + '<div class="pe__result-header">'
        + '<p class="pe__result-overline">Tu diagnóstico EPICLABS®</p>'
        + '<h3 class="pe__result-profile" tabindex="-1" data-pe-focus>'+(p.profile||p.name)+'</h3>'
        + '<p class="pe__result-diagnosis">'+(p.diagnosis||p.tagline)+'</p>'
        + '<div class="pe__result-protocol-tag">Tu protocolo asignado: <b>'+p.name+'</b></div>'
      + '</div>'
      + '<div class="pe__result-body">'
        + '<div class="pe__result-divider"></div>'
        + '<div class="pe__result-section pe__result-section--rationale">'
          + '<p class="pe__result-why">'+why+'</p>'
          + '<div class="pe__result-components">'+components+'</div>'
          + '<p class="pe__result-outcome">'+p.outcome+'</p>'
          + '<div class="pe__result-meta">'
            + '<span class="pe__result-meta-item">'+icon('clock')+'&nbsp;'+p.duration+'</span>'
            + '<span class="pe__result-meta-item">'+icon('bar')+'&nbsp;'+p.level+'</span>'
          + '</div>'
        + '</div>'
        + '<div class="pe__result-divider" style="margin:18px 0 16px;"></div>'
        + priceHtml
        + renderValueStack()
        + signHtml
        + '<div class="pe__cta-area">'+ctaHtml+successHtml+'</div>'
        + trustHtml
        + subHtml
        + planOfferHtml
        + eliteHtml
        + '<div class="pe__result-actions">'
          + '<button class="pe__btn-pdf" data-pe-pdf="'+key+'" type="button" aria-label="Descargar mi protocolo en PDF">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>'
            + '<span>Descargar mi protocolo en PDF</span>'
          + '</button>'
          + '<button class="pe__btn-ghost" data-pe-restart type="button">Evaluar de nuevo</button>'
        + '</div>'
      + '</div>'
      + '</div>';
  }

  /* ════════════════════════════════════════════════════════════════════
     PDF v2 · PREMIUM con recomendaciones inteligentes por perfil
     ════════════════════════════════════════════════════════════════════
     - Fix página en blanco (page-break controlado, sin macros vacíos)
     - 5-6 páginas estructuradas con valor real
     - Recomendaciones de entrenamiento + nutrición basadas en quiz answers
     - Hábitos + recovery + biomarcadores
     - Look premium iOS bubble
     ════════════════════════════════════════════════════════════════════ */

  /* Knowledge base inteligente por perfil · entrenamiento + nutrición + hábitos */
  var SMART_KB = {
    alpha: {
      training: {
        focus: 'Fuerza y potencia',
        splits: '4-5 días/semana · split push-pull-legs o upper/lower',
        sessions: [
          { name: 'Día 1 · Empuje (pecho + hombro + tríceps)', work: 'Press banca 4×5-6 · Press inclinado mancuerna 3×8-10 · Press militar 3×6-8 · Fondos 3×8-12 · Tricep polea 3×10-12' },
          { name: 'Día 2 · Jalón (espalda + bíceps)', work: 'Peso muerto 4×5 · Dominadas 4×6-10 · Remo barra 3×8-10 · Face pull 3×12-15 · Curl barra 3×8-10' },
          { name: 'Día 3 · Piernas (cuádriceps + glúteo)', work: 'Sentadilla 4×5-6 · Prensa 3×8-10 · Hip thrust 3×10 · Extensión 3×12 · Curl femoral 3×10 · Pantorrilla 4×15' },
          { name: 'Día 4 · Empuje volumen', work: 'Press inclinado 4×8-10 · Aperturas 3×12 · Press militar mancuerna 3×10 · Lateral 4×12-15 · Tricep francés 3×10' },
          { name: 'Día 5 · Jalón volumen', work: 'Remo polea 4×10 · Jalón pecho 3×10 · Pullover 3×12 · Curl martillo 3×10 · Cable curl 3×12' }
        ],
        cardio: '2× sesiones LISS Z2 30min (caminar inclinado 6-7 km/h)',
        rest: '90-180 seg entre series pesadas · 60-90 seg series de volumen',
        keyLifts: ['Sentadilla', 'Peso muerto', 'Press banca', 'Dominadas', 'Press militar'],
        tip: 'La creatina te dará 1-2 reps extra en sets pesados desde semana 2-3. Aprovecha esa ventana para subir peso progresivamente (5-10% cada 2-3 semanas).'
      },
      nutrition: {
        calorieGoal: 'Superávit moderado: +300-500 kcal sobre mantenimiento',
        macros: { prot: '2.0 g/kg peso', carb: '4-6 g/kg peso', fat: '0.8-1.0 g/kg peso' },
        preWorkout: 'COREX + 30-40g carbohidrato simple (plátano + avena) 30 min antes',
        postWorkout: '40g proteína whey + 60-80g carbohidrato dentro de los 60 min',
        meals: [
          { time: 'Desayuno · 7-9 AM', items: '4 huevos + 80g avena + frutos rojos + 30g almendras', kcal: '~750' },
          { time: 'Pre-entreno · -30 min', items: 'COREX + plátano + 25g whey', kcal: '~350' },
          { time: 'Post-entreno', items: '180g pollo + 200g arroz + verduras + aguacate', kcal: '~750' },
          { time: 'Snack PM', items: 'Yogur griego + nuez + manzana', kcal: '~400' },
          { time: 'Cena · 8 PM', items: '200g salmón + camote + ensalada con aceite oliva', kcal: '~650' }
        ],
        hydration: '40 ml/kg peso (ej: 70 kg = 2.8 L) + 500ml extra durante entreno',
        keyFoods: ['Pollo/pavo', 'Salmón/atún', 'Huevos enteros', 'Avena', 'Arroz', 'Camote', 'Aguacate', 'Frutos secos']
      },
      recovery: {
        sleep: '7-9 hrs · idealmente 10-11 PM a 6-7 AM',
        habits: ['Sin pantallas 60 min antes de dormir', 'Habitación a 18-20°C', 'Magnesio glicinato 1 hr antes (futuro: añadir BIOMAG)', 'Ducha fría 2 min al despertar'],
        biomarkers: ['Testosterona total + libre (cada 6 meses)', 'Vitamina D (3-monthly)', 'Ferritina', 'Glucosa en ayunas', 'HRV diaria']
      }
    },
    neuro: {
      training: {
        focus: 'Rendimiento cognitivo + físico sin estimulantes',
        splits: '4 días/semana · upper/lower modular',
        sessions: [
          { name: 'Día 1 · Upper potencia', work: 'Press banca 4×6 · Remo barra 3×8 · Press militar 3×8 · Dominadas 3×8 · Curl + tricep 3×10' },
          { name: 'Día 2 · Lower fuerza', work: 'Sentadilla 4×6 · RDL 3×8 · Prensa 3×10 · Curl femoral 3×12 · Pantorrilla 4×15' },
          { name: 'Día 3 · Upper hipertrofia', work: 'Press inclinado 4×10 · Remo polea 4×10 · Lateral 4×12 · Pullover 3×12 · Tricep + curl 3×12' },
          { name: 'Día 4 · Lower posterior', work: 'Peso muerto 4×6 · Hip thrust 4×10 · Bulgara 3×10 · Extensión 3×12 · Plancha 3×45s' }
        ],
        cardio: '2× LISS Z2 (35-45 min caminar/bici) + 1× HIIT corto 15-20 min',
        rest: '90-150 seg series pesadas · 60-90 seg hipertrofia',
        keyLifts: ['Sentadilla', 'Peso muerto', 'Press banca', 'Dominadas'],
        tip: 'PUMPX antes (sin cafeína) te da bombeo sin afectar tu sueño. CREANOVA todos los días para cognitivo. BIOMAG antes de dormir para reparar.'
      },
      nutrition: {
        calorieGoal: 'Mantenimiento o ligero déficit (-200 kcal)',
        macros: { prot: '1.8-2.0 g/kg peso', carb: '3-4 g/kg peso', fat: '1.0 g/kg peso' },
        preWorkout: 'PUMPX 20 min antes + ligero (plátano + 1 tostada)',
        postWorkout: '30g proteína + 40-50g carbs · idealmente alimento integral',
        meals: [
          { time: 'Desayuno · 7-9 AM', items: '3 huevos + pan integral + aguacate + café', kcal: '~600' },
          { time: 'Snack AM', items: 'Yogur griego + nueces + bayas', kcal: '~300' },
          { time: 'Pre-entreno', items: 'PUMPX + plátano + tostada con miel', kcal: '~280' },
          { time: 'Post-entreno', items: '150g pavo + 180g arroz + brócoli + aceite oliva', kcal: '~650' },
          { time: 'Cena · 7 PM', items: '150g pescado + camote + ensalada · BIOMAG después', kcal: '~550' }
        ],
        hydration: '35-40 ml/kg + electrolitos en entrenos largos',
        keyFoods: ['Pescados grasos (omega-3 cognitivo)', 'Aguacate', 'Frutos secos', 'Huevos', 'Bayas', 'Cacao oscuro', 'Té verde', 'Espinaca/kale']
      },
      recovery: {
        sleep: '8-9 hrs estrictas · sleep-window 11 PM - 7 AM',
        habits: ['Luz solar 10 min al despertar (cortisol matutino)', 'Meditación 10 min al día (HRV+)', 'BIOMAG 1 hr antes de dormir', 'Cuarto oscuro · sin luz azul'],
        biomarkers: ['Cortisol matutino + nocturno (rítmico)', 'TSH + T3/T4', 'Vitamina D', 'B12 + folato', 'HRV diaria · Whoop/Oura']
      }
    },
    mitocondria: {
      training: {
        focus: 'Base celular + recuperación celular',
        splits: '3-4 días/semana · fullbody modular',
        sessions: [
          { name: 'Día 1 · Fullbody A', work: 'Sentadilla 3×8 · Press banca 3×8 · Remo 3×10 · Plancha 3×40s · Pantorrilla 3×15' },
          { name: 'Día 2 · Cardio + core', work: 'Caminar inclinado 40 min Z2 · Core circuit 3 rounds (dead bug, plancha lateral, bird dog)' },
          { name: 'Día 3 · Fullbody B', work: 'Peso muerto rumano 3×8 · Press militar 3×8 · Dominadas asistidas 3×8 · Hip thrust 3×10 · Pantorrilla 3×15' },
          { name: 'Día 4 · LISS + flex', work: 'Bici 45 min Z2 · Estiramiento dinámico 15 min · Yoga si disponible' }
        ],
        cardio: 'Foco: Z2 (60-70% FCmax) · 150-180 min/semana acumulados',
        rest: '90-120 seg entre series',
        keyLifts: ['Sentadilla', 'Press banca', 'Peso muerto rumano', 'Dominadas'],
        tip: 'CREANOVA recarga fosfocreatina (energía celular). BIOMAG reduce cortisol nocturno y mejora calidad de sueño = más recovery mitocondrial.'
      },
      nutrition: {
        calorieGoal: 'Mantenimiento · TMB calculado por Mifflin-St Jeor × NEAT',
        macros: { prot: '1.6-1.8 g/kg peso', carb: '3-4 g/kg peso', fat: '1.0-1.2 g/kg peso' },
        preWorkout: 'CREANOVA con cualquier comida 30-60 min antes',
        postWorkout: '25-30g proteína + 30-40g carbs · enfoque integral',
        meals: [
          { time: 'Desayuno', items: 'Omelette con vegetales + tostada + fruta', kcal: '~550' },
          { time: 'Snack', items: 'Smoothie: leche + plátano + cacao + whey', kcal: '~350' },
          { time: 'Comida', items: '150g proteína + 150g carbs complejos + verduras + aceite oliva', kcal: '~650' },
          { time: 'Snack PM', items: 'Mix nueces + manzana + hummus', kcal: '~300' },
          { time: 'Cena temprano · 7 PM', items: '120g pescado + verduras + arroz + BIOMAG noche', kcal: '~500' }
        ],
        hydration: '35 ml/kg · agua filtrada + electrolitos sodio/potasio',
        keyFoods: ['Pescado azul (omega-3)', 'Hígado/vísceras 1×sem (CoQ10, B12)', 'Brócoli/kale', 'Frutos rojos', 'Cacao', 'Aceite de oliva extra virgen', 'Sardinas', 'Espinaca']
      },
      recovery: {
        sleep: '7-9 hrs · respetar ritmo circadiano',
        habits: ['Caminata post-cena 15 min (glucosa)', 'Sauna 2× sem 15-20 min si disponible', 'Ducha fría matutina', 'BIOMAG nocturno'],
        biomarkers: ['Glucosa en ayunas', 'HbA1c', 'Vitamina D', 'B12', 'CoQ10', 'Magnesio sérico']
      }
    },
    base: {
      training: {
        focus: 'Construir hábito · adaptación gradual',
        splits: '3 días/semana · fullbody básico',
        sessions: [
          { name: 'Día 1 · Fullbody Beginner A', work: 'Sentadilla goblet 3×10 · Press banca máquina 3×10 · Remo polea 3×12 · Hip thrust 3×12 · Plancha 3×30s' },
          { name: 'Día 2 · Cardio fácil', work: 'Caminar 30-40 min Z1-Z2 · estiramientos 10 min' },
          { name: 'Día 3 · Fullbody Beginner B', work: 'Prensa pierna 3×12 · Press inclinado mancuerna 3×10 · Jalón pecho 3×12 · Curl 3×12 · Tricep polea 3×12' }
        ],
        cardio: '2-3 sesiones caminata Z2 · 30-45 min',
        rest: '60-90 seg entre series',
        keyLifts: ['Sentadilla', 'Press banca máquina', 'Remo polea', 'Hip thrust'],
        tip: 'PUMPX te da bombeo limpio sin estimulantes mientras entrenas. BIOMAG mejora tu sueño desde la primera noche. Empieza con 3 días/semana y sube cuando se sienta fácil.'
      },
      nutrition: {
        calorieGoal: 'Mantenimiento · enfocarse en HÁBITOS no en macros',
        macros: { prot: '1.4-1.6 g/kg peso', carb: '3-4 g/kg peso', fat: '0.8-1.0 g/kg peso' },
        preWorkout: 'PUMPX + comida ligera 30 min antes',
        postWorkout: 'Comida regular con proteína dentro de 1 hr',
        meals: [
          { time: 'Desayuno', items: '2-3 huevos + tostada + fruta + café/té', kcal: '~450' },
          { time: 'Comida', items: '120g proteína + papa/arroz + ensalada', kcal: '~600' },
          { time: 'Cena temprano', items: '100g proteína + verduras + camote', kcal: '~450' }
        ],
        hydration: '30-35 ml/kg peso',
        keyFoods: ['Pollo', 'Huevos', 'Atún en lata', 'Arroz', 'Papa', 'Plátano', 'Manzana', 'Yogur natural']
      },
      recovery: {
        sleep: '7-9 hrs · horario consistente diario',
        habits: ['Horario fijo de dormir/despertar', 'No celular 30 min antes', 'BIOMAG nocturno', 'Sol matutino 10 min'],
        biomarkers: ['Perfil básico anual', 'Vitamina D', 'Hierro/ferritina', 'TSH']
      }
    },
    peak: {
      training: {
        focus: 'Rendimiento alto + recovery hormonal',
        splits: '5 días/semana · push/pull/legs/upper/lower',
        sessions: [
          { name: 'Día 1 · Push', work: 'Press banca 4×6 · Press inclinado 3×8 · Press militar 3×6 · Lateral 3×12 · Tricep 3×10' },
          { name: 'Día 2 · Pull', work: 'Peso muerto 4×5 · Dominadas 4×8 · Remo polea 3×10 · Face pull 3×12 · Curl 3×10' },
          { name: 'Día 3 · Legs', work: 'Sentadilla 4×5 · RDL 3×8 · Prensa 3×10 · Curl femoral 3×12 · Pantorrilla 4×15' },
          { name: 'Día 4 · Upper hipertrofia', work: 'Press inclinado 4×10 · Remo barra 4×10 · Lateral polea 4×12 · Pullover 3×12 · Brazos 3×12' },
          { name: 'Día 5 · Lower posterior', work: 'Peso muerto rumano 4×6 · Hip thrust 4×10 · Bulgara 3×10 · Glute ham 3×10 · Pantorrilla 3×15' }
        ],
        cardio: 'Mínimo · 1× Z2 30 min en día off',
        rest: '120-180 seg fuerza · 60-90 seg accesorios',
        keyLifts: ['Sentadilla', 'Peso muerto', 'Press banca', 'Press militar'],
        tip: 'COREX te da energía clínica en sesiones pesadas AM. BIOMAG en la noche regula cortisol y soporta testosterona endógena para máximo rendimiento.'
      },
      nutrition: {
        calorieGoal: 'Mantenimiento o ligero superávit (+200 kcal)',
        macros: { prot: '1.8-2.2 g/kg peso', carb: '4-5 g/kg peso', fat: '1.0 g/kg peso' },
        preWorkout: 'COREX + 40g carbs simples 30 min antes',
        postWorkout: '40g whey + 60g carbs dentro de 60 min',
        meals: [
          { time: 'Desayuno', items: '4 huevos + 70g avena + bayas + 25g almendras', kcal: '~700' },
          { time: 'Pre-entreno', items: 'COREX + plátano + 20g whey', kcal: '~320' },
          { time: 'Post-entreno', items: '180g pollo + 200g arroz + verduras', kcal: '~720' },
          { time: 'Snack', items: 'Yogur griego + miel + nueces', kcal: '~400' },
          { time: 'Cena · 7 PM', items: '200g salmón + camote + ensalada · BIOMAG', kcal: '~650' }
        ],
        hydration: '40 ml/kg + electrolitos',
        keyFoods: ['Salmón salvaje', 'Pollo orgánico', 'Huevos pastoreo', 'Avena integral', 'Camote', 'Aguacate', 'Aceite oliva extra virgen', 'Frutos secos']
      },
      recovery: {
        sleep: '8 hrs estrictas · 10-11 PM',
        habits: ['Sol matutino', 'No cafeína después de 2 PM', 'BIOMAG 1 hr antes de dormir', 'Sauna o ducha caliente PM'],
        biomarkers: ['Testosterona total + libre', 'SHBG', 'Estradiol', 'Cortisol diurnal', 'IGF-1', 'Vitamina D', 'Zinc/Magnesio sérico']
      }
    },
    elite: {
      training: {
        focus: 'Alto rendimiento total · sistema completo 24h',
        splits: '5-6 días/semana · upper/lower o push/pull/legs duplicado',
        sessions: [
          { name: 'Día 1 · Push pesado', work: 'Press banca 5×4-5 · Press inclinado 4×6 · Press militar 4×5 · Lateral 4×10 · Tricep 4×8' },
          { name: 'Día 2 · Pull pesado', work: 'Peso muerto 5×3-5 · Dominadas lastradas 4×6 · Remo barra 4×6 · Face pull 4×12 · Curl 4×8' },
          { name: 'Día 3 · Legs pesado', work: 'Sentadilla 5×4-5 · RDL 4×6 · Prensa 4×8 · Curl femoral 4×10 · Pantorrilla 5×12' },
          { name: 'Día 4 · Push volumen', work: 'Press inclinado 4×10 · Aperturas cable 3×12 · Press militar mancuerna 4×10 · Lateral polea 4×12 · Tricep francés 3×10' },
          { name: 'Día 5 · Pull volumen', work: 'Remo polea 4×10 · Jalón pecho 3×10 · Meadows row 3×10 · Cable curl 3×12 · Curl predicador 3×10' },
          { name: 'Día 6 · Legs accesorio', work: 'Hack squat 4×10 · Bulgara 3×10 · Extensión unilateral 3×12 · Glute ham 3×10 · Pantorrilla 4×15' }
        ],
        cardio: '2× sesiones LISS Z2 30 min · 1× HIIT opcional 15 min',
        rest: '180 seg fuerza · 90-120 seg volumen',
        keyLifts: ['Sentadilla', 'Peso muerto', 'Press banca', 'Press militar', 'Dominadas lastradas'],
        tip: 'Stack 24h: COREX matutino para energía clínica · PUMPX si entrenas tarde sin cafeína · CREANOVA todos los días · BIOMAG en la noche. Este sistema potencia entre sí.'
      },
      nutrition: {
        calorieGoal: 'Superávit estratégico +300-500 kcal · ciclo si compites',
        macros: { prot: '2.0-2.4 g/kg peso', carb: '5-7 g/kg peso', fat: '1.0-1.2 g/kg peso' },
        preWorkout: 'COREX + 50g carbs + 20g whey 30-45 min antes',
        postWorkout: '50g whey + 80g carbs + 5g creatina (CREANOVA) inmediato',
        meals: [
          { time: 'Desayuno · 7 AM', items: '5 huevos + 100g avena + bayas + nueces + café', kcal: '~900' },
          { time: 'Snack AM · 10 AM', items: 'Smoothie: 40g whey + plátano + leche + mantequilla maní', kcal: '~550' },
          { time: 'Pre-entreno · 12 PM', items: 'COREX + 1 tostada con miel + plátano', kcal: '~320' },
          { time: 'Post-entreno · 2 PM', items: '200g pollo + 250g arroz + verduras + aguacate', kcal: '~900' },
          { time: 'Snack PM · 5 PM', items: 'Atún + galletas integrales + manzana', kcal: '~450' },
          { time: 'Cena · 8 PM', items: '220g salmón + camote + ensalada + BIOMAG después', kcal: '~750' }
        ],
        hydration: '45-50 ml/kg + 800ml-1L extra durante entreno con electrolitos',
        keyFoods: ['Salmón salvaje', 'Pollo/pavo orgánico', 'Huevos pastoreo', 'Carne magra res', 'Avena', 'Arroz blanco/integral', 'Camote', 'Aguacate', 'Frutos secos', 'Aceite oliva', 'Bayas']
      },
      recovery: {
        sleep: '8-9 hrs · 10 PM - 7 AM no negociables',
        habits: ['Sol matutino 15 min', 'Sin cafeína después de 1 PM', 'Sauna 3× sem 15-20 min', 'BIOMAG + magnesio tópico nocturno', 'Pulsera HR/HRV diaria', 'Estiramiento 15 min antes de dormir'],
        biomarkers: ['Panel hormonal completo (T total, libre, SHBG, E2, DHT)', 'Cortisol diurnal 4 puntos', 'Tiroides completa', 'Vitamina D, B12, ferritina, magnesio', 'CK + LDH (cada 3 meses)', 'CBC/QMP anual']
      }
    }
  };

  /* ── Guía honesta por producto EPIC ──────────────────────────
     "Cómo tomar" (dosis, horario, con/sin alimento) y evidencia de
     alta jerarquía detrás de los ingredientes. SIN cifras inventadas,
     SIN DOIs: solo afirmaciones consolidadas en la literatura.
     Las claves se detectan dentro de p.components (texto del producto). */
  var PE_PRODUCT_GUIDE = [
    {
      match: ['CORE-X', 'COREX', 'CORE X'],
      name: 'CORE-X®',
      role: 'Pre-entreno con energía clínica',
      dose: '1 servicio (1 medida)',
      timing: '20–30 min antes de entrenar',
      food: 'Con poca agua, sin alimento pesado',
      how: 'Disuélvelo en 250–300 ml de agua fría. Evita una segunda dosis el mismo día y no lo tomes después de las 4 PM para no afectar tu sueño.',
      evidence: 'Su base de cafeína y betaína cuenta con respaldo sólido en la literatura para rendimiento e intensidad de entrenamiento de fuerza y potencia. La cafeína es uno de los ayudas ergogénicas mejor documentadas; la betaína anhidra se asocia a soporte en trabajo de fuerza.'
    },
    {
      match: ['PUMP-X', 'PUMPX', 'PUMP X'],
      name: 'PUMP-X®',
      role: 'Bombeo y enfoque sin estimulantes',
      dose: '1 servicio (1 medida)',
      timing: '20–30 min antes de entrenar',
      food: 'Con agua, no requiere alimento',
      how: 'Mezcla en 300 ml de agua. Al no llevar estimulantes, puedes usarlo en entrenos de la tarde o la noche sin comprometer el descanso.',
      evidence: 'La L-citrulina es de los precursores de óxido nítrico mejor estudiados para vasodilatación y bombeo muscular durante el ejercicio de resistencia. Su perfil sin estimulantes permite el enfoque sin la carga de la cafeína.'
    },
    {
      match: ['CREANOVA', 'CREA-NOVA', 'CREATINA'],
      name: 'CREANOVA®',
      role: 'Creatina de grado farmacéutico',
      dose: '1 servicio (creatina monohidrato)',
      timing: 'Cualquier hora del día, todos los días',
      food: 'Indistinto, con o sin alimento',
      how: 'La clave es la constancia diaria, no el horario. Tómalo incluso los días que no entrenas para mantener saturada la fosfocreatina muscular. Acompáñalo de buena hidratación.',
      evidence: 'La creatina monohidrato es uno de los suplementos deportivos con mayor evidencia de eficacia y seguridad: respaldo consistente para fuerza, potencia y masa muscular magra, y un perfil de seguridad ampliamente documentado en uso prolongado.'
    },
    {
      match: ['BIO-MAG', 'BIOMAG', 'BIO MAG', 'MAGNESIO'],
      name: 'BIO-MAG®',
      role: 'Magnesio glicinato para recuperación',
      dose: '1 servicio (magnesio glicinato)',
      timing: '45–60 min antes de dormir',
      food: 'Puede tomarse con un alimento ligero',
      how: 'Su forma glicinato es de alta biodisponibilidad y buena tolerancia digestiva. Tomarlo de noche apoya la rutina de descanso y la recuperación nocturna.',
      evidence: 'El magnesio participa en cientos de reacciones enzimáticas, incluyendo función neuromuscular y metabolismo energético. La forma glicinato se reconoce por su biodisponibilidad y tolerancia. Su rol es de soporte cuando la ingesta dietética es subóptima.'
    }
  ];

  function peGuideForProtocol(p) {
    var blob = (p.components || []).join(' ').toUpperCase();
    return PE_PRODUCT_GUIDE.filter(function (g) {
      return g.match.some(function (m) { return blob.indexOf(m) !== -1; });
    });
  }

  function buildProtocolPDF(key) {
    var p = PROTOCOLS[key];
    var prod = PRODUCTS[key] || {};
    if (!p) return;
    var why = generateWhyText(key, state.answers || {});
    var kb = SMART_KB[key] || SMART_KB.mitocondria;
    var guide = peGuideForProtocol(p);
    if (!guide.length) {
      guide = [{
        name: prod.title || p.name, role: 'Protocolo EPIC',
        dose: '1 servicio', timing: p.timing || '20–30 min antes de entrenar',
        food: 'Según indicación de etiqueta',
        how: 'Sigue la dosificación de la etiqueta. La constancia diaria es lo que activa los resultados.',
        evidence: 'Formulado con dosis clínicas y sin proprietary blends, sobre ingredientes con respaldo en la literatura científica.'
      }];
    }

    var components = p.components.map(function(c){ return '<li>'+esc(c)+'</li>'; }).join('');

    var price = (prod.price && prod.price > 0)
      ? '<p class="pdoc-price"><b>Inversión:</b> '+money(prod.price)+(prod.compare && prod.compare>prod.price ? ' · antes '+money(prod.compare) : '')+'</p>'
      : '';

    var url = prod.url || '/collections/all';
    var siteOrigin = (function(){ try{ return location.origin; }catch(e){ return 'https://epiclabs.mx'; }})();
    var linkAbs = (url.indexOf('http') === 0) ? url : (siteOrigin + url);

    // Cómo tomar cada producto EPIC (la parte clave del obsequio)
    var dosingHtml = guide.map(function(g){
      return '<tr>'
        + '<td><b>'+esc(g.name)+'</b><br><span class="pdoc-muted">'+esc(g.role||'')+'</span></td>'
        + '<td>'+esc(g.dose)+'</td>'
        + '<td>'+esc(g.timing)+'</td>'
        + '<td>'+esc(g.food)+'</td>'
        + '</tr>';
    }).join('');

    var howCardsHtml = guide.map(function(g){
      return '<div class="pdoc-card">'
        + '<h3>'+esc(g.name)+'</h3>'
        + '<p style="font-size:11.5px;margin:0;">'+esc(g.how)+'</p>'
        + '</div>';
    }).join('');

    // Evidencia de alta jerarquía (afirmaciones consolidadas, sin cifras inventadas)
    var evidenceHtml = guide.map(function(g){
      return '<div class="pdoc-card pdoc-card-green">'
        + '<h3>'+esc(g.name)+'</h3>'
        + '<p style="font-size:11.5px;margin:0;">'+esc(g.evidence)+'</p>'
        + '</div>';
    }).join('');

    // Lineamientos generales (NO un plan personalizado)
    var nutriGuidelines = [
      'Prioriza proteína de calidad en cada comida (carnes magras, huevo, pescado, lácteos o fuentes vegetales).',
      'Construye tu plato alrededor de alimentos reales: verduras, carbohidratos de buena densidad y grasas saludables.',
      'Ajusta tus calorías a tu objetivo: déficit moderado para recomposición, mantenimiento o ligero superávit para ganancia.',
      'Hidrátate bien a lo largo del día; suma electrolitos en entrenos largos o con mucho sudor.',
      'La constancia diaria pesa más que cualquier comida perfecta aislada.'
    ];
    var trainGuidelines = [
      'Entrena fuerza 3–5 días por semana, priorizando ejercicios compuestos (sentadilla, peso muerto, press, remo, dominadas).',
      'Aplica sobrecarga progresiva: sube peso, repeticiones o calidad de ejecución de forma gradual.',
      'Cuida la técnica antes que la carga; deja 1–3 repeticiones en reserva en la mayoría de tus series.',
      'Suma cardio de baja intensidad (zona 2) para salud cardiovascular y recuperación.',
      'Duerme 7–9 horas: el progreso se consolida durante el descanso.'
    ];
    var nutriHtml = nutriGuidelines.map(function(x){ return '<li>'+esc(x)+'</li>'; }).join('');
    var trainHtml = trainGuidelines.map(function(x){ return '<li>'+esc(x)+'</li>'; }).join('');

    var html = ''
      + '<style>'
        // Reset + base
        + '.pdoc{font-family:"Poppins",-apple-system,system-ui,sans-serif;color:#0E1B4D;line-height:1.5;}'
        + '.pdoc *{box-sizing:border-box;}'
        // Page-break controls (CRÍTICOS para sin página en blanco)
        + '.pdoc-page{page-break-inside:avoid;break-inside:avoid;}'
        + '.pdoc-newpage{page-break-before:always;break-before:always;}'
        // Section headers
        + '.pdoc h1{font-family:"Poppins",sans-serif;font-size:24px;font-weight:800;margin:0 0 4px;letter-spacing:-.02em;line-height:1.15;}'
        + '.pdoc h2{font-family:"Poppins",sans-serif;font-size:14px;font-weight:700;color:#1A6BF5;margin:20px 0 8px;text-transform:uppercase;letter-spacing:.7px;padding-bottom:4px;border-bottom:2px solid rgba(26,107,245,.18);}'
        + '.pdoc h3{font-family:"Poppins",sans-serif;font-size:12.5px;font-weight:700;color:#0E1B4D;margin:12px 0 4px;}'
        + '.pdoc-sub{color:#5A6085;font-size:12.5px;margin:0 0 14px;line-height:1.5;}'
        + '.pdoc-tag{display:inline-block;background:'+(p.accent||'#1A6BF5')+';color:#fff;font-weight:700;font-size:10px;padding:5px 11px;border-radius:100px;letter-spacing:.6px;text-transform:uppercase;margin-bottom:8px;}'
        // Cards
        + '.pdoc-card{background:linear-gradient(160deg,rgba(26,107,245,.05),rgba(26,107,245,.01));border:1px solid rgba(26,107,245,.16);border-radius:12px;padding:12px 14px;margin:8px 0 12px;page-break-inside:avoid;break-inside:avoid;}'
        + '.pdoc-card-gold{background:linear-gradient(160deg,rgba(245,158,11,.07),rgba(245,158,11,.01));border-color:rgba(245,158,11,.22);}'
        + '.pdoc-card-green{background:linear-gradient(160deg,rgba(22,163,74,.06),rgba(22,163,74,.01));border-color:rgba(22,163,74,.22);}'
        // Tables
        + '.pdoc table{width:100%;border-collapse:collapse;font-size:11.5px;margin:8px 0;}'
        + '.pdoc th,.pdoc td{padding:7px 9px;text-align:left;border-bottom:1px solid #E6E8F2;vertical-align:top;}'
        + '.pdoc th{background:#F4F7FF;font-size:10px;text-transform:uppercase;letter-spacing:.5px;color:#5A6085;font-weight:700;}'
        + '.pdoc-kcal{color:#1A6BF5;font-weight:700;text-align:right;white-space:nowrap;}'
        // Components / chips
        + '.pdoc-components{display:flex;flex-wrap:wrap;gap:5px;padding:0;margin:6px 0 0;list-style:none;}'
        + '.pdoc-components li{background:rgba(26,107,245,.08);color:#1A6BF5;font-size:10.5px;font-weight:600;padding:4px 9px;border-radius:100px;list-style:none;}'
        + '.pdoc-chip{display:inline-block;background:rgba(22,163,74,.08);color:#0E7A3A;font-size:10.5px;font-weight:600;padding:4px 9px;border-radius:100px;margin:3px 4px 3px 0;}'
        // Sessions
        + '.pdoc-session{padding:10px 12px;background:#FBFCFE;border:1px solid #E6E9F2;border-radius:10px;margin-bottom:8px;page-break-inside:avoid;break-inside:avoid;}'
        + '.pdoc-session-name{display:block;font-size:12px;font-weight:800;color:#0E1B4D;margin-bottom:3px;font-family:"Poppins",sans-serif;}'
        + '.pdoc-session-work{font-size:11px;color:#46506E;margin:0;line-height:1.4;}'
        // Lists
        + '.pdoc-list{margin:6px 0 8px;padding-left:4px;list-style:none;}'
        + '.pdoc-list li{font-size:11.5px;margin:4px 0;line-height:1.4;padding-left:16px;position:relative;}'
        + '.pdoc-list li::before{content:"";position:absolute;left:2px;top:6px;width:5px;height:5px;border-radius:50%;background:'+(p.accent||'#1A6BF5')+';}'
        // Macros stack
        + '.pdoc-macros{display:flex;gap:8px;margin:8px 0 10px;}'
        + '.pdoc-macro{flex:1;text-align:center;padding:8px;background:#F4F7FF;border-radius:10px;}'
        + '.pdoc-macro-lbl{font-size:9px;color:#5A6085;text-transform:uppercase;letter-spacing:.5px;font-weight:700;margin-bottom:2px;}'
        + '.pdoc-macro-val{font-size:13px;font-weight:800;color:#0E1B4D;font-family:"Poppins",sans-serif;}'
        // Footer signatures
        + '.pdoc-sign{display:flex;gap:12px;align-items:center;padding:12px 14px;background:#F4F7FF;border-radius:14px;margin-top:14px;}'
        + '.pdoc-sign img{width:42px;height:42px;border-radius:50%;object-fit:cover;}'
        + '.pdoc-sign-by{font-size:9.5px;color:#5A6085;text-transform:uppercase;letter-spacing:.5px;}'
        + '.pdoc-sign-name{font-size:13px;font-weight:700;color:#0E1B4D;font-family:"Poppins",sans-serif;}'
        + '.pdoc-sign-cred{font-size:10px;color:#5A6085;}'
        + '.pdoc-cta{display:inline-block;background:#1A6BF5;color:#fff!important;text-decoration:none;font-weight:700;padding:11px 20px;border-radius:100px;font-size:12.5px;margin-top:8px;}'
        + '.pdoc-price{font-size:12.5px;color:#0E1B4D;margin:8px 0;padding:8px 12px;background:#F4F7FF;border-radius:10px;border-left:3px solid '+(p.accent||'#1A6BF5')+';}'
        + '.pdoc-tip{padding:10px 13px;background:linear-gradient(135deg,rgba(34,211,238,.08),rgba(26,107,245,.04));border:1px solid rgba(26,107,245,.18);border-radius:11px;font-size:11.5px;color:#0E1B4D;margin:8px 0;}'
        + '.pdoc-tip b{color:#1A6BF5;}'
        + '.pdoc-muted{color:#5A6085;font-size:10px;font-weight:600;}'
        + '.pdoc-disclaimer{font-size:9.5px;color:#7A809C;line-height:1.45;margin:10px 0 0;}'
      + '</style>'

      + '<div class="pdoc">'

      // ═══════════════ PÁGINA 1 · PROTOCOLO ═══════════════
      + '<div class="pdoc-page">'
        + '<span class="pdoc-tag">'+esc(p.badge||'Protocolo asignado')+'</span>'
        + '<h1>'+esc(p.profile||p.name)+'</h1>'
        + '<p class="pdoc-sub">'+esc(p.diagnosis||p.tagline||'')+'</p>'

        + '<h2>Tu protocolo</h2>'
        + '<div class="pdoc-card"><b>'+esc(p.name)+'</b><ul class="pdoc-components">'+components+'</ul></div>'

        + '<h2>Por qué este protocolo</h2>'
        + '<p style="font-size:12px;margin:0">'+esc(why)+'</p>'

        + '<h2>Resultado esperado</h2>'
        + '<p style="font-size:12px;margin:0">'+esc(p.outcome||'')+'</p>'

        + '<h2>Duración recomendada</h2>'
        + '<p style="font-size:12px;margin:0">'+esc(p.duration||'')+' · Nivel: '+esc(p.level||'')+'</p>'

        + price
      + '</div>'

      // ═══════════════ PÁGINA 2 · CÓMO TOMAR (lo clave) ═══════════════
      + '<div class="pdoc-newpage pdoc-page">'
        + '<h1>Cómo tomar tu protocolo</h1>'
        + '<p class="pdoc-sub">La guía exacta de cada producto EPIC: dosis, horario y si va con o sin alimento. Esta es la parte que marca la diferencia.</p>'

        + '<h2>Dosis · horario · alimento</h2>'
        + '<table><thead><tr><th>Producto</th><th>Dosis</th><th>Horario</th><th>Alimento</th></tr></thead><tbody>'+dosingHtml+'</tbody></table>'

        + '<h2>Notas de uso por producto</h2>'
        + howCardsHtml

        + '<div class="pdoc-tip"><b>La constancia gana:</b> la dosis diaria sostenida, no la dosis aumentada, es lo que activa los resultados en el horizonte de '+esc(p.duration||'4–8 semanas')+'. Respeta los horarios y mantén buena hidratación.</div>'
      + '</div>'

      // ═══════════════ PÁGINA 3 · EVIDENCIA CIENTÍFICA ═══════════════
      + '<div class="pdoc-newpage pdoc-page">'
        + '<h1>La evidencia detrás</h1>'
        + '<p class="pdoc-sub">Por qué estos ingredientes y no otros. Afirmaciones consolidadas en la literatura científica de alta jerarquía sobre los activos de tu protocolo.</p>'

        + '<h2>Respaldo por ingrediente</h2>'
        + evidenceHtml

        + '<p class="pdoc-disclaimer">Resumen educativo basado en la evidencia disponible sobre ingredientes individuales. No sustituye consejo médico. Los resultados varían según cada persona, su alimentación, entrenamiento y descanso.</p>'
      + '</div>'

      // ═══════════════ PÁGINA 4 · LINEAMIENTOS GENERALES ═══════════════
      + '<div class="pdoc-newpage pdoc-page">'
        + '<h1>Lineamientos generales</h1>'
        + '<p class="pdoc-sub">Principios base de nutrición y entrenamiento. Son lineamientos generales, no un plan personalizado: tu plan real con tus datos vive en la app EPIC.</p>'

        + '<h2>Nutrición · principios</h2>'
        + '<ul class="pdoc-list">'+nutriHtml+'</ul>'

        + '<h2>Entrenamiento · principios</h2>'
        + '<ul class="pdoc-list">'+trainHtml+'</ul>'

        + '<div class="pdoc-tip"><b>Quieres tu plan a la medida:</b> estos lineamientos son el punto de partida. En la app EPIC personalizamos dieta y rutina con tus datos reales (peso, objetivo, disponibilidad y progreso).</div>'
      + '</div>'

      // ═══════════════ PÁGINA 5 · APP + CIERRE ═══════════════
      + '<div class="pdoc-newpage pdoc-page">'
        + '<h1>Tu siguiente paso</h1>'
        + '<p class="pdoc-sub">Este protocolo es tu base. La personalización real (dieta y rutina con tus datos) la construyes en la app EPIC.</p>'

        + '<h2>Personaliza en la app</h2>'
        + '<div class="pdoc-card pdoc-card-gold">'
          + '<p style="font-size:12px;margin:0 0 4px;"><b>La app EPIC convierte este protocolo en tu plan.</b></p>'
          + '<p style="font-size:11.5px;margin:0;">Con tus datos reales personaliza tu nutrición y entrenamiento, registra tu progreso y ajusta el plan semana a semana. Entra en epiclabs.mx/pages/tu-progreso.</p>'
        + '</div>'

        + '<h2>Listo para empezar</h2>'
        + '<div class="pdoc-card">'
          + '<p style="font-size:12.5px;margin:0 0 8px;"><b>'+esc(p.name)+'</b> está formulado para tu perfil específico. Sin proprietary blends, con dosis clínicas reales y certificación triple en cada lote.</p>'
          + '<a class="pdoc-cta" href="'+esc(linkAbs)+'">Comprar mi protocolo →</a>'
        + '</div>'

        + '<h2>Garantía</h2>'
        + '<ul class="pdoc-list">'
          + '<li><b>30 días de garantía total</b>, si no sientes el cambio te devolvemos tu dinero</li>'
          + '<li><b>Envío 24 h</b> hábiles a todo México</li>'
          + '<li><b>Certificado físico</b> en cada caja (lote, fecha, análisis)</li>'
          + '<li><b>Asesoría 1:1</b> · escríbenos por WhatsApp cuando tengas duda</li>'
        + '</ul>'

        + '<div class="pdoc-sign">'
          + (CFG.founder_photo ? '<img src="'+esc(CFG.founder_photo)+'" alt="">' : '')
          + '<div>'
            + '<div class="pdoc-sign-by">Protocolo validado por</div>'
            + '<div class="pdoc-sign-name">'+esc(CFG.founder_name||'LN. Esp. Roberto Franco')+'</div>'
            + '<div class="pdoc-sign-cred">'+esc(CFG.founder_cred||'Nutriólogo · Cédula Prof. 15287197 SEP')+'</div>'
          + '</div>'
        + '</div>'

        + '<div class="pdoc-tip" style="margin-top:14px;"><b>Guarda este PDF:</b> es tu guía de protocolo. Recuerda que la personalización real de dieta y rutina, con tus datos, la haces en la app EPIC.</div>'
      + '</div>'

      + '</div>';

    if (window.EpicPDF && typeof window.EpicPDF.print === 'function') {
      window.EpicPDF.print('Protocolo ' + (p.name || 'EPIC'), html, {
        accent: p.accent || '#1A6BF5',
        skipMacros: true,
        subtitle: p.tagline || '',
        meta: [p.duration || '4-8 semanas', p.level || 'Personalizado']
      });
      try { track && track('pdf_downloaded', { protocol: key }); } catch(_){}
      try { (window.EpicHaptic && window.EpicHaptic.success()); } catch(_){}
      try { (window.EpicIsland && window.EpicIsland.notify('Tu protocolo está en tus archivos', 'Revísalo cuando quieras · listo offline', {kind:'success', icon:'check', duration:5500})); } catch(_){}
    } else {
      var w = window.open('', '_blank');
      if (w) { w.document.write('<title>Protocolo '+esc(p.name)+'</title>'+html); w.document.close(); setTimeout(function(){ w.print(); }, 300); }
    }
  }

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function hexToRgb(hex) {
    return parseInt(hex.slice(1,3),16)+','+parseInt(hex.slice(3,5),16)+','+parseInt(hex.slice(5,7),16);
  }

  /* ── CAPTURA DE LEAD antes del resultado ── */
  function needLead() {
    if (!CFG.lead_capture) return false;
    try { if (localStorage.getItem('epicLeadDone')) return false; } catch (e) {}
    return true;
  }
  function renderLeadGate(key) {
    var p = PROTOCOLS[key];
    var wa = CFG.lead_whatsapp
      ? '<input class="pe__lead-input" type="tel" inputmode="tel" data-pe-lead-wa placeholder="WhatsApp (opcional)" autocomplete="tel">'
      : '';
    return '<div class="pe__screen pe__lead">'
      + '<span class="pe__aurora" aria-hidden="true"></span>'
      + '<div class="pe__lead-badge">' + icon('lab', 22) + '</div>'
      + '<h2 class="pe__lead-title" tabindex="-1" data-pe-focus>' + (CFG.lead_title || 'Tu protocolo está listo.') + '</h2>'
      + '<p class="pe__lead-sub">' + (CFG.lead_sub || '') + '</p>'
      + '<div class="pe__lead-reveal">' + icon('lock', 15) + '&nbsp;Tu mejor match: <b>' + p.name + '</b></div>'
      + '<form class="pe__lead-form" data-pe-lead-form novalidate>'
        + '<input class="pe__lead-input" type="email" required data-pe-lead-email placeholder="tu@correo.com" autocomplete="email">'
        + wa
        + '<button class="pe__btn pe__btn-primary" type="submit">' + (CFG.lead_cta || 'Ver mi protocolo') + '&nbsp;&nbsp;' + icon('arrow') + '</button>'
      + '</form>'
      + '<button class="pe__lead-skip" type="button" data-pe-lead-skip>Prefiero solo ver mi resultado</button>'
      + '<p class="pe__lead-priv">Sin spam. Te llega tu protocolo + guía. Baja cuando quieras.</p>'
      + '</div>';
  }
  function sendKlaviyo(email, wa, key) {
    if (!CFG.klaviyo_key || !CFG.klaviyo_list || !email) return;
    try {
      var props = { protocolo: key || '', fuente: 'quiz' };
      if (wa) props.whatsapp = wa;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyo_key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Quiz Protocolo', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: CFG.klaviyo_list } } } } })
      }).catch(function () {});
    } catch (e) {}
  }
  function handleLead(skip) {
    var wrap = document.getElementById('pe-body');
    var screen = wrap && wrap.querySelector('.pe__screen:not(.pe__screen--leaving)');
    var key = state.result;
    if (!skip && screen) {
      var em = screen.querySelector('[data-pe-lead-email]');
      var email = em ? (em.value || '').trim() : '';
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        if (em) { em.focus(); em.classList.add('pe__lead-input--err'); }
        return;
      }
      var waEl = screen.querySelector('[data-pe-lead-wa]');
      var waVal = waEl ? (waEl.value || '').trim() : '';
      sendKlaviyo(email, waVal, key);
      try { localStorage.setItem('epicLeadDone', email); } catch (e) {}
      track('lead_captured', { protocol: key, whatsapp: waVal ? true : false });
    } else {
      track('lead_skipped', { protocol: key });
    }
    state.screen = 'result';
    showScreen(renderResult(key), true);
  }

  /* ── Oferta secundaria (no bloqueante) · captura de email del resultado ──
     Reutiliza sendKlaviyo() (la misma lógica del lead gate). No navega a otra
     pantalla: el usuario ya está en su resultado. Tras enviar, dispara el PDF
     del plan personalizado y muestra una confirmación inline. */
  function handlePlanLead(form) {
    if (!form) return;
    var em = form.querySelector('[data-pe-plan-email]');
    var email = em ? (em.value || '').trim() : '';
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      if (em) { em.focus(); em.classList.add('pe__lead-input--err'); }
      return;
    }
    if (em) em.classList.remove('pe__lead-input--err');
    var key = state.result;
    var waEl = form.querySelector('[data-pe-plan-wa]');
    var waVal = waEl ? (waEl.value || '').trim() : '';
    sendKlaviyo(email, waVal, key);
    try { localStorage.setItem('epicLeadDone', email); } catch (e) {}
    track('lead_captured', { protocol: key, whatsapp: waVal ? true : false, source: 'result_plan_offer' });
    /* Confirmación inline + entrega del PDF (sin bloquear el resultado) */
    var offer = form.closest ? form.closest('[data-pe-plan-offer]') : null;
    var ok = offer ? offer.querySelector('[data-pe-plan-ok]') : null;
    if (form && form.parentNode) form.style.display = 'none';
    if (ok) ok.hidden = false;
    try { (window.EpicHaptic && window.EpicHaptic.confirm()); } catch (_) {}
    try { buildProtocolPDF(key); } catch (e) {}
  }

  /* ── Recentra la tarjeta del quiz en el viewport ──────────
     Evita que la pregunta quede arriba/abajo y haya que hacer scroll. */
  function recenterCard() {
    var section = document.getElementById('epiclabs-protocol-engine');
    if (!section) return;
    var card = section.querySelector('.pe__card') || section;
    var header = document.querySelector(
      '.section-header, .header-wrapper, #shopify-section-header, header[role="banner"], .header, sticky-header'
    );
    var offset = header ? header.offsetHeight : 0;
    if (offset > 200 || offset < 0) offset = 80;
    var pad = offset + 16;
    var rect = card.getBoundingClientRect();
    /* Si el inicio de la tarjeta ya está cómodo en pantalla, no saltamos */
    if (rect.top >= offset - 2 && rect.top <= window.innerHeight * 0.42) return;
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = Math.max(0, rect.top + window.pageYOffset - pad);
    window.scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' });
  }

  /* ── Transición de pantalla (fade + morph de altura) ────── */
  function showScreen(html, recenter) {
    var wrap = document.getElementById('pe-body');
    if (!wrap) return;
    var current = wrap.querySelector('.pe__screen:not(.pe__screen--leaving)');
    var startH = wrap.offsetHeight;

    var holder = document.createElement('div');
    holder.innerHTML = html.trim();
    var nextEl = holder.firstElementChild;
    if (!nextEl) return;

    /* Medir altura destino sin pintar */
    nextEl.classList.add('pe__screen--measure');
    wrap.appendChild(nextEl);
    var endH = nextEl.offsetHeight;
    nextEl.classList.remove('pe__screen--measure');

    /* Entrar oculto (mismo tick → sin parpadeo) */
    nextEl.classList.add('pe__screen--entering');

    /* Morph de altura del card */
    if (startH > 4) {
      wrap.style.height = startH + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { wrap.style.height = endH + 'px'; });
      });
    } else {
      wrap.style.height = endH + 'px';
    }

    /* Sale la pantalla actual (fade rápido) */
    var lead = 20;
    if (current) {
      lead = 165;
      current.classList.add('pe__screen--leaving');
      setTimeout(function () { if (current && current.parentNode) current.parentNode.removeChild(current); }, 210);
    }

    /* Entra la nueva tras el fade-out */
    setTimeout(function () { nextEl.classList.remove('pe__screen--entering'); }, lead);
    setTimeout(function () { wrap.style.height = ''; }, 580);

    bindScreenEvents(nextEl);

    /* Recentrar la tarjeta para que la pregunta/resultado quede visible */
    if (recenter) requestAnimationFrame(function () { requestAnimationFrame(recenterCard); });

    /* Sin foco programático: evitamos el recuadro visible en cualquier navegador */
  }

  /* ── Eventos de pantalla ────────────────────────────────── */
  function bindScreenEvents(screen) {
    var el;
    if ((el = screen.querySelector('[data-pe-start]')))   el.addEventListener('click', handleStart);
    if ((el = screen.querySelector('[data-pe-back]')))    el.addEventListener('click', handleBack);
    if ((el = screen.querySelector('[data-pe-restart]'))) el.addEventListener('click', handleRestart);

    screen.querySelectorAll('[data-pe-resume]').forEach(function (b) {
      b.addEventListener('click', function () { handleResume(b.getAttribute('data-pe-resume')); });
    });
    screen.querySelectorAll('[data-pe-option]').forEach(function (b) {
      b.addEventListener('click', function () {
        handleOption(b.getAttribute('data-pe-qid'), b.getAttribute('data-pe-option'));
      });
    });
    var cart = screen.querySelector('[data-pe-add-cart]');
    if (cart) cart.addEventListener('click', function () { handleAddToCart(cart.getAttribute('data-pe-add-cart')); });

    var leadForm = screen.querySelector('[data-pe-lead-form]');
    if (leadForm) leadForm.addEventListener('submit', function (e) { e.preventDefault(); handleLead(false); });
    var leadSkip = screen.querySelector('[data-pe-lead-skip]');
    if (leadSkip) leadSkip.addEventListener('click', function () { handleLead(true); });

    /* Oferta secundaria de email DENTRO del resultado (PLAN PERSONALIZADO en PDF) */
    var planForm = screen.querySelector('[data-pe-plan-form]');
    if (planForm) planForm.addEventListener('submit', function (e) { e.preventDefault(); handlePlanLead(planForm); });

    screen.querySelectorAll('[data-pe-elite]').forEach(function (l) {
      l.addEventListener('click', function () { track('upsell_clicked', { to_protocol: 'elite', from: state.result }); });
    });
    screen.querySelectorAll('[data-pe-view-product]').forEach(function (l) {
      l.addEventListener('click', function () { track('checkout_clicked', { protocol: l.getAttribute('data-pe-view-product'), action: 'view_product' }); });
    });
    var pdfBtn = screen.querySelector('[data-pe-pdf]');
    if (pdfBtn) pdfBtn.addEventListener('click', function () {
      var k = pdfBtn.getAttribute('data-pe-pdf');
      try { (window.EpicHaptic && window.EpicHaptic.confirm()); } catch(_){}
      buildProtocolPDF(k);
    });
    screen.querySelectorAll('[data-pe-subscribe]').forEach(function (l) {
      l.addEventListener('click', function () { track('subscribe_clicked', { protocol: l.getAttribute('data-pe-subscribe') }); });
    });
  }

  /* ── Handlers ───────────────────────────────────────────── */
  function handleStart() {
    state.answers = {}; state.index = 0; state.result = null; state.screen = 'question';
    clearMemory();
    setStep(0);
    track('protocol_start', { source: document.referrer || 'direct' });
    showScreen(renderQuestion(state.flow[0]), true);
  }

  function handleResume(kind) {
    var saved = loadMemory();
    if (!saved) { handleStart(); return; }
    state.answers = saved.answers || {};
    state.index   = saved.index || 0;
    state.result  = saved.result || null;
    if (kind === 'result' && state.result) {
      state.screen = 'result';
      setStep(0, true);
      track('protocol_resumed', { protocol: state.result });
      showScreen(renderResult(state.result), true);
    } else {
      state.screen = 'question';
      if (state.index >= state.flow.length) state.index = state.flow.length - 1;
      setStep(state.index);
      track('quiz_resumed', { step: state.index + 1 });
      showScreen(renderQuestion(state.flow[state.index]), true);
    }
  }

  function handleOption(qId, value) {
    if (state.busy) return;
    state.busy = true;

    var wrap = document.getElementById('pe-body');
    var screen = wrap ? wrap.querySelector('.pe__screen:not(.pe__screen--leaving)') : null;
    if (screen) {
      screen.querySelectorAll('[data-pe-option]').forEach(function (b) { b.classList.remove('pe__option--selected'); });
      var sel = screen.querySelector('[data-pe-option="'+value+'"]');
      if (sel) sel.classList.add('pe__option--selected');
    }

    state.answers[qId] = value;
    saveMemory();
    track('question_answer', { question: qId, answer: value, step: state.index + 1 });

    setTimeout(function () {
      state.index++;
      if (state.index < state.flow.length) {
        setStep(state.index);
        showScreen(renderQuestion(state.flow[state.index]), true);
      } else {
        startProcessing();
      }
      state.busy = false;
    }, 230);
  }

  function handleBack() {
    if (state.busy || state.index <= 0) return;
    state.index--;
    delete state.answers[state.flow[state.index]];
    saveMemory();
    setStep(state.index);
    showScreen(renderQuestion(state.flow[state.index]), true);
  }

  function handleRestart() {
    state.answers = {}; state.index = 0; state.result = null; state.screen = 'intro';
    clearMemory();
    setStep(-1);
    track('quiz_restarted', {});
    showScreen(renderIntro(null), true);
  }

  /* ── Loader: el isotipo EPIC se INTEGRA y DESINTEGRA (partículas) ── */
  function isotypeLoader(canvas, reduced) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return { progress: function(){}, kill: function(){} };
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var r = canvas.getBoundingClientRect();
    var W = Math.round(r.width)  || 232; if (W < 80) W = 232;
    var H = Math.round(r.height) || 232; if (H < 80) H = 232;
    canvas.width = W * DPR; canvas.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

    /* 3 barras del isotipo (paralelogramos) en caja 0..100 */
    var BARS = [
      { bl:[33,38], tl:[40,22], br:[92,38] },
      { bl:[10,60], tl:[17,44], br:[92,60] },
      { bl:[33,82], tl:[40,66], br:[92,82] }
    ];
    var COUNT = [60, 86, 60];
    var pad = 0.14;
    function mx(x){ return (pad + (x/100)*(1-2*pad)) * W; }
    function my(y){ return (pad + (y/100)*(1-2*pad)) * H; }

    /* Polígonos sólidos del isotipo — para el cierre "armado" nítido */
    var POLY = BARS.map(function(B){
      var bl=[mx(B.bl[0]),my(B.bl[1])], tl=[mx(B.tl[0]),my(B.tl[1])], br=[mx(B.br[0]),my(B.br[1])];
      return [bl, tl, [tl[0]+(br[0]-bl[0]), tl[1]+(br[1]-bl[1])], br];
    });
    function fillBars(alpha){
      if (alpha <= 0) return;
      ctx.globalAlpha = alpha; ctx.fillStyle = '#1A6BF5';
      for (var k=0;k<POLY.length;k++){ var q=POLY[k];
        ctx.beginPath(); ctx.moveTo(q[0][0],q[0][1]);
        for (var j=1;j<q.length;j++) ctx.lineTo(q[j][0],q[j][1]);
        ctx.closePath(); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    var P = [];
    for (var b = 0; b < BARS.length; b++) {
      var B = BARS[b];
      var e1x = B.tl[0]-B.bl[0], e1y = B.tl[1]-B.bl[1];
      var e2x = B.br[0]-B.bl[0], e2y = B.br[1]-B.bl[1];
      for (var i = 0; i < COUNT[b]; i++) {
        var u = Math.random(), v = Math.random();
        var ang = Math.random()*6.283, rad = (0.42 + Math.random()*0.72) * W;
        P.push({
          tx: mx(B.bl[0] + u*e1x + v*e2x),
          ty: my(B.bl[1] + u*e1y + v*e2y),
          sx: W/2 + Math.cos(ang)*rad,
          sy: H/2 + Math.sin(ang)*rad,
          d: Math.random()*0.22,
          ph: Math.random()*6.283,
          r: 1.5 + Math.random()*1.3,
          col: Math.random() < 0.22 ? '#7FB0FF' : (Math.random() < 0.5 ? '#1A6BF5' : '#2E7BFF')
        });
      }
    }

    var prog = 0, raf = 0, alive = true;
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    function ease(t){ return t<0?0:t>1?1:1-Math.pow(1-t,3); }

    function frame() {
      if (!alive) return;
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var time = (now - t0) / 1000;

      /* Curva: integra (0→.5) · sostiene (.5→.86) · FINALIZA armado (.86→1). Termina ARMADO. */
      var form = prog < 0.5 ? ease(prog/0.5) : 1;
      var finalize = (prog - 0.86) / 0.14; finalize = finalize<0?0:finalize>1?1:finalize;
      if (reduced) { form = prog > 0.25 ? 1 : ease(prog/0.25); finalize = prog > 0.7 ? 1 : 0; }
      var fz = 1 - Math.pow(1 - finalize, 2);
      var sweep = (prog-0.3)/0.5;

      ctx.clearRect(0,0,W,H);

      /* Glow de cierre detrás del isotipo */
      if (fz > 0) {
        var g = ctx.createRadialGradient(W/2, H*0.5, 0, W/2, H*0.5, W*0.52);
        g.addColorStop(0, 'rgba(46,123,255,'+(0.20*fz)+')');
        g.addColorStop(1, 'rgba(46,123,255,0)');
        ctx.fillStyle = g; ctx.fillRect(0,0,W,H);
      }

      /* Pop sutil de "lock-in" (vuelve a escala 1 exacta al terminar) */
      var scale = 1 + 0.05 * Math.sin(fz * Math.PI);
      ctx.save();
      ctx.translate(W/2, H/2); ctx.scale(scale, scale); ctx.translate(-W/2, -H/2);

      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        var f = (form - p.d) / (1 - p.d); if (f<0) f=0; if (f>1) f=1;
        if (reduced) f = form;
        var jit = (f > 0.6 && !reduced) ? (1 - fz) : 0;   /* el jitter se apaga al finalizar */
        var x = p.sx + (p.tx - p.sx)*f + (jit ? Math.sin(time*2 + p.ph)*1.1 : 0);
        var y = p.sy + (p.ty - p.sy)*f + (jit ? Math.cos(time*2.3 + p.ph)*1.1 : 0);
        var alpha = (0.22 + 0.78*f) * (1 - 0.55*fz);      /* las partículas ceden ante el sólido */
        var rr = p.r * (0.6 + 0.4*f);
        if (sweep > 0 && sweep < 1.1 && f > 0.7 && fz < 0.4) {
          var sx = sweep * W;
          if (Math.abs(x - sx) < 26) { alpha = 1; rr += 0.9; }
        }
        ctx.globalAlpha = alpha;
        ctx.fillStyle = p.col;
        ctx.beginPath(); ctx.arc(x, y, rr, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;

      /* El isotipo sólido se ARMA y queda nítido al final */
      fillBars(fz);

      ctx.restore();
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);

    return {
      progress: function(p){ prog = p; },
      kill: function(){ alive = false; if (raf) cancelAnimationFrame(raf); }
    };
  }

  /* ── Procesamiento ──────────────────────────────────────── */
  function startProcessing() {
    state.screen = 'processing';
    setStep(0, true);
    showScreen(renderProcessing(), true);

    var wrap = document.getElementById('pe-body');
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pctEl = wrap ? wrap.querySelector('[data-pe-pct]') : null;
    var statusEl = wrap ? wrap.querySelector('[data-pe-status]') : null;
    var canvas = wrap ? wrap.querySelector('[data-pe-iso]') : null;

    var loader = canvas ? isotypeLoader(canvas, rm) : null;

    var scores = computeScores(state.answers);
    var key = selectProtocol(scores);
    state.result = key;
    saveMemory();
    track('protocol_generated', { protocol: key, scores: scores });
    track('quiz_completed', { protocol: key, answers: state.answers });

    var STAT = [[0,'Analizando tu perfil de rendimiento'],[0.32,'Cruzando 6 protocolos clínicos'],[0.62,'Calibrando tu ruta fisiológica'],[0.9,'Protocolo localizado']];
    /* FIX iOS: en "Reduce Motion" (común en iPhone) el loader corría 700ms → no se alcanzaba
       a ver formarse el isotipo. Lo subimos a 2200ms (animación ya simplificada, sin jitter)
       para que SÍ se perciba el armado del isotipo, sin volverse mareante. */
    var DUR = rm ? 2200 : 5000;
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    (function tick() {
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var p = Math.min(1, (now - t0) / DUR);
      if (pctEl) pctEl.textContent = Math.round((1 - Math.pow(1 - p, 2.2)) * 100);
      if (loader) loader.progress(p);
      if (statusEl) { for (var i = STAT.length - 1; i >= 0; i--) { if (p >= STAT[i][0]) { if (statusEl.textContent !== STAT[i][1]) statusEl.textContent = STAT[i][1]; break; } } }
      if (p < 1) requestAnimationFrame(tick);
    })();

    setTimeout(function () {
      if (loader) loader.kill();
      if (statusEl) statusEl.textContent = 'Protocolo listo';
      /* Roberto aprobó: NUNCA bloquear con el lead gate. El resultado + el
         botón de agregar al carrito se muestran de inmediato. La captura de
         email vive DENTRO del resultado como oferta secundaria no bloqueante
         (envío del PLAN PERSONALIZADO en PDF). */
      state.screen = 'result';
      showScreen(renderResult(key), true);
    }, rm ? 1000 : 5400);
  }

  /* ── Carrito ────────────────────────────────────────────── */
  function handleAddToCart(variantId) {
    if (!variantId || state.busy) return;
    state.busy = true;
    var btn = document.querySelector('[data-pe-add-cart="'+variantId+'"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
    .then(function () {
      var ok = document.getElementById('pe-cart-success');
      if (ok) ok.classList.add('pe--visible');
      if (btn) btn.style.display = 'none';
      var sec = document.querySelector('[data-pe-view-product]');
      if (sec) { sec.classList.remove('pe__btn-secondary'); sec.classList.add('pe__btn-primary'); }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      track('bundle_added', { protocol: state.result, variant_id: variantId });
      state.busy = false;
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'AGREGAR PROTOCOLO AL CARRITO'; }
      state.busy = false;
    });
  }

  /* ── Analytics ──────────────────────────────────────────── */
  function track(name, data) {
    data = data || {};
    data.brand = 'epiclabs'; data.module = 'protocol_engine';
    data.timestamp = new Date().toISOString();
    if (window.gtag) { try { window.gtag('event', name, data); } catch (e) {} }
    if (window.fbq)  { try { window.fbq('trackCustom', name, data); } catch (e) {} }
    if (window.ttq && window.ttq.track) { try { window.ttq.track(name, data); } catch (e) {} }
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      try { window.Shopify.analytics.publish(name, data); } catch (e) {}
    }
    if (window.EPICLABS_PE_DEBUG) console.log('[EPICLABS PE]', name, data);
  }

  /* ── Personalización por tráfico ────────────────────────── */
  function applyPersonalization() {
    try {
      var utm = new URLSearchParams(window.location.search).get('utm_source') || '';
      if (utm === 'tiktok') CFG.overline = 'EVALUACIÓN CLÍNICA EPICLABS®';
      else if (utm === 'meta' || utm === 'instagram' || utm === 'facebook') CFG.overline = 'SISTEMA CLÍNICO DE EVALUACIÓN';
    } catch (e) {}
  }

  /* ── Teclado (selección rápida 1–9) ─────────────────────── */
  function bindKeyboard() {
    if (window.__epiclabsPEKeys) return;
    window.__epiclabsPEKeys = true;
    document.addEventListener('keydown', function (e) {
      if (state.screen !== 'question') return;
      var n = parseInt(e.key, 10);
      if (!n || n < 1 || n > 9) return;
      var wrap = document.getElementById('pe-body');
      var screen = wrap && wrap.querySelector('.pe__screen:not(.pe__screen--leaving)');
      if (!screen) return;
      var opts = screen.querySelectorAll('[data-pe-option]');
      if (opts[n - 1]) { e.preventDefault(); opts[n - 1].click(); }
    });
  }

  /* ── Scroll suave global hacia el motor ─────────────────── */
  function smoothScrollTo(target) {
    var header = document.querySelector(
      '.section-header, .header-wrapper, #shopify-section-header, header[role="banner"], .header, sticky-header'
    );
    var offset = header ? header.offsetHeight : 0;
    if (offset > 200 || offset < 0) offset = 80;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 20;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function bindScrollLinks() {
    if (window.__epiclabsPEScroll) return;
    window.__epiclabsPEScroll = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('#epiclabs-protocol-engine') === -1) return;
      var target = document.getElementById('epiclabs-protocol-engine');
      if (!target) return;
      e.preventDefault();
      smoothScrollTo(target);
      /* No persistimos hash para evitar que reload cargue directo al motor en vez del hero */
      track('engine_scroll_link', { from: a.textContent ? a.textContent.trim().slice(0, 40) : 'link' });
    }, false);
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    var section = document.getElementById('epiclabs-protocol-engine');
    if (!section || !document.getElementById('pe-body')) return;
    if (section.getAttribute('data-pe-ready') === '1') return;
    section.setAttribute('data-pe-ready', '1');

    applyPersonalization();
    buildProgress();
    bindKeyboard();
    bindScrollLinks();
    setStep(-1);

    var saved = loadMemory();
    state.screen = 'intro';
    showScreen(renderIntro(saved));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target ? e.target.querySelector('#epiclabs-protocol-engine') : null;
    if (sec) sec.removeAttribute('data-pe-ready');
    setTimeout(init, 60);
  });

})();
